function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$1.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$2.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$3.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$4 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/* Built-in method references that are verified to be native. */
var Promise = _getNative(_root, 'Promise');

var _Promise = Promise;

/* Built-in method references that are verified to be native. */
var Set = _getNative(_root, 'Set');

var _Set = Set;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (_Map && getTag(new _Map) != mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$3.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$1] = typedArrayTags[numberTag] =
typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] =
typedArrayTags[setTag$1] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
    setTag$2 = '[object Set]';

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike_1(value) &&
      (isArray_1(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer_1(value) || isTypedArray_1(value) || isArguments_1(value))) {
    return !value.length;
  }
  var tag = _getTag(value);
  if (tag == mapTag$2 || tag == setTag$2) {
    return !value.size;
  }
  if (_isPrototype(value)) {
    return !_baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$4.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */

/**
 * Traverses properties on objects and arrays. If an intermediate property is
 * either null or undefined, it is instead returned. The purpose of this method
 * is to simplify extracting properties from a chain of maybe-typed properties.
 *
 * === EXAMPLE ===
 *
 * Consider the following type:
 *
 *   const props: {
 *     user: ?{
 *       name: string,
 *       friends: ?Array<User>,
 *     }
 *   };
 *
 * Getting to the friends of my first friend would resemble:
 *
 *   props.user &&
 *   props.user.friends &&
 *   props.user.friends[0] &&
 *   props.user.friends[0].friends
 *
 * Instead, `idx` allows us to safely write:
 *
 *   idx(props, _ => _.user.friends[0].friends)
 *
 * The second argument must be a function that returns one or more nested member
 * expressions. Any other expression has undefined behavior.
 *
 * === NOTE ===
 *
 * The code below exists for the purpose of illustrating expected behavior and
 * is not meant to be executed. The `idx` function is used in conjunction with a
 * Babel transform that replaces it with better performing code:
 *
 *   props.user == null ? props.user :
 *   props.user.friends == null ? props.user.friends :
 *   props.user.friends[0] == null ? props.user.friends[0] :
 *   props.user.friends[0].friends
 *
 * All this machinery exists due to the fact that an existential operator does
 * not currently exist in JavaScript.
 */

function idx(input, accessor) {
  try {
    return accessor(input);
  } catch (error) {
    if (error instanceof TypeError) {
      if (nullPattern.test(error)) {
        return null;
      } else if (undefinedPattern.test(error)) {
        return undefined;
      }
    }
    throw error;
  }
}

/**
 * Some actual error messages for null:
 *
 * TypeError: Cannot read property 'bar' of null
 * TypeError: Cannot convert null value to object
 * TypeError: foo is null
 * TypeError: null has no properties
 * TypeError: null is not an object (evaluating 'foo.bar')
 * TypeError: null is not an object (evaluating '(" undefined ", null).bar')
 */
var nullPattern = /^null | null$|^[^(]* null /i;
var undefinedPattern = /^undefined | undefined$|^[^(]* undefined /i;

idx.default = idx;
var idx_1 = idx;

var prefix = "dorik";

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = _basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString_1(string);
  return string && string.replace(reLatin, _deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr;

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords;

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$1 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo$1 + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString_1(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return _hasUnicodeWord(string) ? _unicodeWords(string) : _asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos$1, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return _arrayReduce(words_1(deburr_1(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder;

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = _createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

var kebabCase_1 = kebabCase;

var isTypeVar = function isTypeVar(value) {
  return isObject_1(value) && 'key' in value && 'value' in value;
};
var withVar = function withVar(value) {
  return "var(".concat(value.key, ")");
};
var getColorVars = function getColorVars(colors) {
  return colors.filter(function (v) {
    return v;
  }).map(function (col) {
    return "".concat(col.key, ": ").concat(col.value, ";");
  }).join('\n');
};

var keys = Object.keys;
var defaultValues = {
  textShadow: {
    x: '0px',
    y: '0px',
    blur: '0px',
    color: '#000000'
  },
  boxShadow: {
    x: '0px',
    y: '0px',
    blur: '0px',
    spread: '0px',
    color: '#000000',
    type: ''
  }
};
var buildStyle = {
  compoundProps: {
    border: 'leadingProps',
    margin: 'leadingProps',
    padding: 'leadingProps',
    filter: 'functionKeyed',
    transform: 'functionKeyed',
    color: 'colorVar',
    fill: 'colorVar',
    backgroundColor: 'colorVar',
    boxShadow: 'inlineValues',
    textShadow: 'inlineValues',
    textDecoration: 'inlineValues'
  },
  customProps: ['size'],
  colorVar: function colorVar(prop, value) {
    value = isTypeVar(value) ? withVar(value) : value;
    return "".concat(kebabCase_1(prop), ": ").concat(value, ";\n");
  },

  /**
   * @param {string} prop camelCased CSS property name
   * @param {*} value the value should be processed
   * @returns {string} CSS declarations
   */
  css: function css(prop, value, getParentStyle) {
    if (value === '' || value == null) return '';

    if (this.hasOwnProperty(prop)) {
      return this[prop](value);
    } else if (keys(this.compoundProps).includes(prop)) {
      var compoundMethod = this[this.compoundProps[prop]].bind(this);
      return compoundMethod(prop, value);
    } else if (this.customProps.includes(prop)) {
      var style = '';
      Object.entries(value).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        style += "".concat(key, ":").concat(val, ";");
      });
      return style;
    } else {
      return this.simpleStyle(prop, value);
    }
  },

  /**
   * @param {string} prop camelCased CSS property name
   * @param {string} value a single line string value
   * @returns {string} CSS declaration
   */
  simpleStyle: function simpleStyle(prop, value) {
    prop = prop.startsWith('_') ? prop.slice(1) : prop;
    return "  ".concat(kebabCase_1(prop), ": ").concat(value, "; \n");
  },

  /**
   * @param {string} parentProp base property to be prefixed
   * @param {Array<array>} arr iterable values
   * @returns {string} CSS declarations
   */
  mapToCss: function mapToCss(parentProp, arr) {
    return arr.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          prop = _ref4[0],
          value = _ref4[1];

      if (value) {
        value = isTypeVar(value) ? withVar(value) : value;
        return "  ".concat(parentProp, "-").concat(prop, ": ").concat(value, ";");
      }
    }).join('\n');
  },

  /**
   * @param {string} prop base property name
   * @param {array<array>} value iterable values
   * @returns {string} CSS declarations
   */
  leadingProps: function leadingProps(prop, value) {
    return this.mapToCss(kebabCase_1(prop), value) + '\n';
  },

  /**
   * @param {array} value an iterable values
   * @returns {string} CSS declaration
   */
  functionKeyed: function functionKeyed(prop, value) {
    value = Object.entries(value);
    var result = value.map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];

      return value && "".concat(key, "(").concat(value, ")");
    }).join(' ').trim();
    return result && "  ".concat(kebabCase_1(prop), ": ").concat(result, ";\n");
  },

  /**
   * This method returns simple inline values of a complex input
   * ex: `text-shadow: 4px 5px 10px #000;
   *
   * @param {string} prop CSS property name, camelCased
   * @param {object} value An object of values to be prepared as CSS string
   * @returns {string} CSS declaration
   */
  inlineValues: function inlineValues(prop, value, getParentStyle) {
    var stringValue;
    var parentValues = typeof getParentStyle === 'function' && getParentStyle(prop);
    var mergedValues = Object.assign({}, defaultValues[prop], parentValues, value);

    if ('color' in mergedValues) {
      mergedValues.color = isTypeVar(mergedValues.color) ? withVar(mergedValues.color) : mergedValues.color;
    }

    if (false === value._enabled || value.type === 'none') {
      stringValue = 'none';
    } else {
      stringValue = Object.entries(mergedValues).filter(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 1),
            key = _ref8[0];

        return key.charAt(0) !== '_';
      }).map(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            _ = _ref10[0],
            value = _ref10[1];

        return value;
      }).join(' ');
    }

    return "".concat(kebabCase_1(prop), ": ").concat(stringValue, ";\n");
  },

  /**
   * Combine background image and gradient into one CSS declaration
   * @param {Object} param0
   * @returns CSS declaration
   */
  backgroundImage: function backgroundImage(_ref11) {
    var image = _ref11.image,
        gradient = _ref11.gradient;
    var result = [];

    if (image) {
      result.push("url(\"".concat(image, "\")"));
    }

    if (gradient) {
      result.push(this.backgroundGradient(gradient));
    }

    return "background-image: ".concat(result.join(', '), ";\n");
  },

  /**
   * @param {array<array>} itrator background gradient CSS processable values
   * @returns {string} CSS declaration
   */
  backgroundGradient: function backgroundGradient(itrator) {
    var gradient = new Map(itrator);
    var radialDirection = gradient.get('radialDirection');

    var _gradient$get = gradient.get('start'),
        _gradient$get2 = _slicedToArray(_gradient$get, 2),
        startColor = _gradient$get2[0],
        startPos = _gradient$get2[1];

    var _gradient$get3 = gradient.get('end'),
        _gradient$get4 = _slicedToArray(_gradient$get3, 2),
        endColor = _gradient$get4[0],
        endPos = _gradient$get4[1];

    var direction = gradient.get('direction');
    var shape = gradient.get('shape');
    var type = gradient.get('type');
    var gradientDir = direction;
    startColor = isTypeVar(startColor) ? withVar(startColor) : startColor;
    endColor = isTypeVar(endColor) ? withVar(endColor) : endColor;

    if (type === 'radial') {
      gradientDir = "".concat(shape, " at ").concat(radialDirection);
    }

    var cssString = '';
    cssString += type === 'linear' ? 'linear-gradient(' : 'radial-gradient(';
    cssString += "".concat(gradientDir, ", ").concat(startColor, " ").concat(startPos, ", ").concat(endColor, " ").concat(endPos);
    cssString += ')';
    return cssString;
  },

  /**
   * @param {array<array>} itrator box shadow CSS processable values
   * @returns {string} CSS declaration
   */
  xboxShadow: function xboxShadow(value) {
    var mergedValues = _objectSpread2({}, defaultValues.boxShadow, {}, value);

    var result = mergedValues.type !== 'none' ? Object.values(mergedValues).join(' ') : 'none';
    return "box-shadow: ".concat(result, ";\n");
  }
};

function styleDeclaration() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var settingStyle = arguments.length > 1 ? arguments[1] : undefined;
  var cssString = '';
  Object.entries(style).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        prop = _ref2[0],
        value = _ref2[1];

    // if settings is turned off for specific property
    var disabled = settingStyle && settingStyle[prop] === false; // adding CSS declaration with existing ones.

    cssString += disabled ? '' : buildStyle.css(prop, value);
  });
  return cssString;
}

var Styles =
/*#__PURE__*/
function () {
  /**
   *
   * @param {any} item
   */
  function Styles(item) {
    _classCallCheck(this, Styles);

    this.item = item;
  }
  /**
   * @returns {string} className prefixed with `.dorik`
   */


  _createClass(Styles, [{
    key: "parseStyle",

    /**
     *
     * @param {string} [path] Style object location
     * @returns {string} CSS string
     */
    value: function parseStyle() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'style';
      var style = path.split('/').reduce(function (last, item) {
        return last && last.hasOwnProperty(item) ? last[item] : null;
      }, this.item);
      return style && styleDeclaration(style);
    }
  }, {
    key: "combined",
    value: function combined() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'style';
      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.className;
      return "\n            ".concat(this.getGeneralStyle(path, className), "\n            ").concat(this.getPseudoStyles(path, className), "\n            ").concat(this.getMediaStyles(path, className), "\n        ");
    }
  }, {
    key: "getGeneralStyle",
    value: function getGeneralStyle() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'style';
      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.className;
      var styles = this.parseStyle(path);
      return styles ? "".concat(className, " {\n                ").concat(styles, "\n            }") : '';
    }
    /**
     *
     * @param {string} [path]
     * @param {string} [className]
     * @returns {string} style blocks for all available pseudo classes
     */

  }, {
    key: "getPseudoStyles",
    value: function getPseudoStyles() {
      var _this = this;

      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'style';
      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.className;
      var _this$item$pseudoClas = this.item.pseudoClass,
          pseudoClass = _this$item$pseudoClas === void 0 ? {} : _this$item$pseudoClas;
      var pseudoClasses = Object.keys(pseudoClass);
      var styles = pseudoClasses.map(function (pseudo) {
        var style = _this.parseStyle("pseudoClass/".concat(pseudo, "/").concat(path));

        if (!style) return;
        return "".concat(className, ":").concat(pseudo, " {\n                ").concat(style, "\n            }");
      });
      return styles.join('\n');
    }
    /**
     *
     * @param {string} [path]
     * @param {string} [className]
     * @returns {string} style blocks for all available media queries
     */

  }, {
    key: "getMediaStyles",
    value: function getMediaStyles() {
      var _this2 = this;

      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'style';
      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.className;
      var queries = [{
        path: "media/tablet/".concat(path),
        maxSize: '1023px'
      }, {
        path: "media/mobile/".concat(path),
        maxSize: '767px'
      }];
      var media = queries.map(function (query) {
        return _objectSpread2({}, query, {
          style: _this2.parseStyle(query.path)
        });
      });
      var styles = media.filter(function (item) {
        return item.style;
      }).map(function (item) {
        return "@media all and (max-width: ".concat(item.maxSize, ") {\n                    ").concat(className, " {\n                        ").concat(item.style, "\n                    }\n                }");
      });
      return styles.join('\n');
    }
  }, {
    key: "getCustomMediaStyles",
    value: function getCustomMediaStyles() {
      var _this3 = this;

      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'style';
      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.className;
      var callBack = arguments.length > 2 ? arguments[2] : undefined;
      var queries = [{
        path: "media/tablet/".concat(path),
        maxSize: '1023px'
      }, {
        path: "media/mobile/".concat(path),
        maxSize: '767px'
      }];
      var stylePath = queries.map(function (query) {
        return query;
      }).map(function (_ref) {
        var path = _ref.path,
            maxSize = _ref.maxSize;
        return [path.split('/').reduce(function (last, item) {
          return last && last.hasOwnProperty(item) ? last[item] : null;
        }, _this3.item), maxSize];
      });
      var styles = stylePath.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            path = _ref3[0],
            maxSize = _ref3[1];

        return "@media all and (max-width: ".concat(maxSize, ") {\n                    ").concat(className, " {\n                        ").concat(callBack(path), "\n                    }\n                }");
      });
      return styles.join('\n');
    }
  }, {
    key: "className",
    get: function get() {
      var _this$item = this.item,
          id = _this$item.id,
          type = _this$item.type;
      return ".".concat(prefix, "-").concat(type, "-").concat(id);
    }
  }]);

  return Styles;
}();

function nav(item) {
  var _btn$items;

  var _item$links = item.links,
      links = _item$links === void 0 ? {} : _item$links,
      _item$btn = item.btn,
      btn = _item$btn === void 0 ? {} : _item$btn,
      settings = item.settings,
      style = item.style;
  var styles = new Styles(item);
  var className = styles.className;

  var generateStyles = function generateStyles(_ref) {
    var from = _ref.from,
        wrapperClass = _ref.wrapperClass,
        itemClass = _ref.itemClass,
        iconClass = _ref.iconClass;
    var gap = from.gap,
        align = from.align,
        icon = from.icon;
    var wrapperAlign = getLinksAlign(align);

    var _getFlexGap = getFlexGap(gap, style === null || style === void 0 ? void 0 : style.flexDirection),
        _getFlexGap2 = _slicedToArray(_getFlexGap, 2),
        _getFlexGap2$ = _getFlexGap2[0],
        itemsGap = _getFlexGap2$ === void 0 ? '' : _getFlexGap2$,
        _getFlexGap2$2 = _getFlexGap2[1],
        lastItemNoGap = _getFlexGap2$2 === void 0 ? '' : _getFlexGap2$2;

    var _getIconStyle = getIconStyle(icon),
        _getIconStyle$iconGap = _getIconStyle.iconGap,
        iconGap = _getIconStyle$iconGap === void 0 ? '' : _getIconStyle$iconGap,
        _getIconStyle$iconSty = _getIconStyle.iconStyles,
        iconStyles = _getIconStyle$iconSty === void 0 ? '' : _getIconStyle$iconSty,
        _getIconStyle$iconPos = _getIconStyle.iconPosition,
        iconPosition = _getIconStyle$iconPos === void 0 ? '' : _getIconStyle$iconPos;

    var transition = (style === null || style === void 0 ? void 0 : style.transition) ? "transition: ".concat(style.transition, ";") : '';
    var linkListStyle = wrapperAlign ? "".concat(wrapperClass, " {\n                ").concat(wrapperAlign, "\n            }") : '';
    var linkStyle = itemsGap || transition || iconPosition ? "".concat(itemClass, " {\n                    ").concat(itemsGap, "\n                    ").concat(transition, "\n                    ").concat(iconPosition, "\n                }") : '';
    var itemGapStyle = itemsGap ? "@media all and (max-width: 767px) {\n                ".concat(itemClass, " {\n                    margin-right: auto;\n                    ").concat(itemsGap.replace('right', 'bottom'), "\n                }\n            }") : '';
    var linkIconStyle = iconStyles || iconGap ? "".concat(iconClass, " {\n                    ").concat(iconStyles, "\n                    ").concat(iconGap, "\n                }") : '';
    var lastItemNoGapStyle = lastItemNoGap ? "".concat(wrapperClass, " > li:last-child > a {\n                ").concat(lastItemNoGap, "\n            }") : '';
    return "\n            ".concat(linkListStyle, "\n            ").concat(linkStyle, "\n            ").concat(itemGapStyle, "\n            ").concat(lastItemNoGapStyle, "\n            ").concat(linkIconStyle, "\n        ");
  }; // TOGGLE BUTTON


  var toggleBtnStyle = styles.combined('toggle/style', "".concat(className, " .").concat(prefix, "-navbar--toggle")); // LINK STYLES

  var linkItemClass = "".concat(className, " .").concat(prefix, "-nav--link");
  var linkItemCombined = styles.combined('links/style', linkItemClass);
  var linkStyles = generateStyles({
    from: links,
    itemClass: linkItemClass,
    wrapperClass: "".concat(className, " .").concat(prefix, "-nav--links"),
    iconClass: "".concat(className, " .").concat(prefix, "-nav--link-icon")
  }); // BUTTONS STYLES

  var btnItemClass = "".concat(className, " .").concat(prefix, "-nav--btn");
  var btnItemCombined = styles.combined('btn/style', btnItemClass);
  var btnStyles = generateStyles({
    from: btn,
    itemClass: btnItemClass,
    wrapperClass: "".concat(className, " .").concat(prefix, "-nav--btns"),
    iconClass: "".concat(className, " .").concat(prefix, "-nav--btn-icon")
  }); // INDIVIDUAL BUTTON STYLES

  var btnItemStyles = btn === null || btn === void 0 ? void 0 : (_btn$items = btn.items) === null || _btn$items === void 0 ? void 0 : _btn$items.map(function (item) {
    var style = {};
    Object.entries(item).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      if (key.startsWith('style/')) {
        var prop = key.replace('style/', '');
        style[prop] = value;
      }
    });
    var styles = new Styles({
      style: style
    });
    return styles.getGeneralStyle('style', "".concat(className, " .").concat(prefix, "-nav--btn-").concat(item.id));
  }); // STICKY NAV BACKGROUND

  var stickyStyle = (settings === null || settings === void 0 ? void 0 : settings.stickyBG) ? "".concat(className, "-wrapper.sticky, \n            ").concat(className, "-wrapper.expended {\n                background-color: ").concat(settings.stickyBG, "\n            }") : '';
  return "\n        ".concat(stickyStyle, "\n        /* Toggle Button*/\n        ").concat(toggleBtnStyle, "\n        /* Links */\n        ").concat(linkStyles, "\n        ").concat(linkItemCombined, "\n        /* Buttons */\n        ").concat(btnStyles, "\n        ").concat(btnItemCombined, "\n        ").concat((btnItemStyles === null || btnItemStyles === void 0 ? void 0 : btnItemStyles.join('\n')) || '', "\n    ");
}

function getLinksAlign(align) {
  var flexDirection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'row';
  if (!align) return '';
  var alignValue = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
  }[align];
  var alignProp = {
    row: 'justify-content',
    column: 'align-items'
  }[flexDirection];
  return "".concat(alignProp, ": ").concat(alignValue, ";");
}

function getFlexGap(gap) {
  var flexDirection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'row';
  if (!gap) return '';
  var gapProp = {
    row: 'margin-right',
    column: 'margin-bottom'
  }[flexDirection];
  var gapStyle = "".concat(gapProp, ": ").concat(gap, ";");
  var lastItemNoGap = "".concat(gapProp, ": 0;");
  return [gapStyle, lastItemNoGap];
}

function getIconStyle(icon) {
  var result = {};
  var styles = new Styles(icon);
  var iconStyles = styles.parseStyle();
  result.iconStyles = iconStyles ? iconStyles : '';

  if (icon === null || icon === void 0 ? void 0 : icon.position) {
    var iconPosValue = {
      left: 'row',
      right: 'row-reverse'
    }[icon.position];
    var iconPosition = "flex-direction: ".concat(iconPosValue, ";");
    result.iconPosition = iconPosition;
  }

  if (icon === null || icon === void 0 ? void 0 : icon.gap) {
    var iconGapProp = {
      left: 'margin-right',
      right: 'margin-left'
    }[(icon === null || icon === void 0 ? void 0 : icon.position) || 'left'];
    var iconGap = "".concat(iconGapProp, ": ").concat(icon.gap, ";");
    result.iconGap = iconGap;
  }

  return result;
}

var getClassName = (function (item) {
  return ".".concat(prefix, "-").concat(item.type, "-").concat(item.id);
});

function row(item) {
  var className = getClassName(item);
  var devices = [['tablet', '1023px'], ['mobile', '767px']];
  var _item$media = item.media,
      media = _item$media === void 0 ? {} : _item$media,
      _item$content = item.content,
      content = _item$content === void 0 ? [] : _item$content,
      _item$settings = item.settings,
      settings = _item$settings === void 0 ? {} : _item$settings;
  var reverseColumn = settings.reverseColumn;
  var mediaString = '';

  if (settings.columnGap) {
    mediaString += "".concat(className, ".flex {\n            margin-left: calc(-").concat(settings.columnGap, " / 2);\n            margin-right: calc(-").concat(settings.columnGap, " / 2);\n        }\n        ").concat(className, " [class*=\"col-\"] {\n            padding-left: calc(").concat(settings.columnGap, " / 2);\n            padding-right: calc(").concat(settings.columnGap, " / 2);\n        }\n");
  }

  devices.map(function (_ref) {
    var _media$d, _media$d$settings;

    var _ref2 = _slicedToArray(_ref, 2),
        d = _ref2[0],
        size = _ref2[1];

    var isReversible = content.map(function (col) {
      return idx_1(col, function (props) {
        return props.media[d].attr.__class__columnSize;
      });
    }).every(function (v) {
      return !v || v === '1/1';
    });

    if (reverseColumn) {
      mediaString += "@media screen and (max-width: ".concat(size, ") {\n                            ").concat(className, " {\n                                ").concat(isReversible ? 'flex-direction: column-reverse;' : '', "\n                            }\n                        }\n");
    }

    var columnGap = (_media$d = media[d]) === null || _media$d === void 0 ? void 0 : (_media$d$settings = _media$d.settings) === null || _media$d$settings === void 0 ? void 0 : _media$d$settings.columnGap;

    if (columnGap) {
      mediaString += "@media screen and (max-width: ".concat(size, ") {\n                ").concat(className, ".flex {\n                    margin-left: calc(-").concat(columnGap, " / 2);\n                    margin-right: calc(-").concat(columnGap, " / 2);\n                }\n                ").concat(className, " [class*=\"col-\"] {\n                    padding-left: calc(").concat(columnGap, " / 2);\n                    padding-right: calc(").concat(columnGap, " / 2);\n                }\n             }\n");
    }
  });
  return mediaString;
}

function tabs (item) {
  var _item$tabs = item.tabs,
      tabs = _item$tabs === void 0 ? {} : _item$tabs;
  var styles = new Styles(item);
  var className = styles.className;
  var wrapperClass = "".concat(className, " .accordion-tabs");
  var tabAllowedClass = "".concat(className, " .tabs-allowed");
  var tabWrapperClass = "".concat(wrapperClass, " .tabs-tab-list");
  var panelClass = "".concat(wrapperClass, " .tabs-panel");
  var tabsClass = "".concat(tabWrapperClass, " li .tabs-trigger");
  var accordionClass = "".concat(panelClass, " .accordion-trigger");

  var activeBorderWidth = tabs.panelStyle._border.split(' ').shift();

  return "\n".concat(tabWrapperClass, " {\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n").concat(tabWrapperClass, " li {\n  margin: 0;\n}\n\n").concat(styles.combined('tabs/tabsStyle', tabsClass), "\n").concat(styles.combined('tabs/tabsStyle', accordionClass), "\n\n").concat(tabsClass, " {\n  border-bottom: none;\n  display: none;\n  margin: 0 5px 0 1px;\n  text-decoration: none;\n}\n\n").concat(styles.combined("tabs/activeStyle", "".concat(tabsClass, ".is-selected")), "\n").concat(styles.combined("tabs/activeStyle", "".concat(tabsClass, ".is-selected:hover")), "\n").concat(styles.combined("tabs/activeStyle", "".concat(tabsClass, ".is-selected:active")), "\n\n").concat(tabsClass, ".is-selected,").concat(tabsClass, ".is-selected:hover,").concat(tabsClass, ".is-selected:active{\n  border-bottom-width:").concat(activeBorderWidth, ";\n}\n\n").concat(styles.combined("tabs/activeStyle", "".concat(panelClass, ".is-open .accordion-trigger")), "\n").concat(styles.combined("tabs/activeStyle", "".concat(panelClass, ".is-open .accordion-trigger:hover")), "\n").concat(styles.combined("tabs/activeStyle", "".concat(panelClass, ".is-open .accordion-trigger:active")), "\n\n").concat(tabsClass, ":active {\n  outline: none;\n}\n\n").concat(panelClass, " .accordion-trigger:focus,\n").concat(panelClass, " .accordion-trigger:active{\n  outline:none;\n}\n\n").concat(panelClass, " {\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n\n").concat(panelClass, ":not(:first-of-type) {\n  border-top: ").concat(tabs.panelStyle._border, ";\n}\n\n\n").concat(styles.combined('tabs/contentStyle', "".concat(panelClass, " .content")), "\n\n").concat(panelClass, ".is-hidden .content {\n  display: none;\n}\n\n").concat(panelClass, ":active,\n").concat(panelClass, ":focus {\n  outline: none;\n}\n\n").concat(className, " .is-initialized.tabs-allowed .tabs-panel {\n  display: inherit;\n}\n\n").concat(accordionClass, " {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n").concat(accordionClass, " .accordion-trigger-icon {\n  pointer-events: none;\n}\n\n").concat(tabAllowedClass, " .tabs-panel.fake-panel {\n  display: none;\n}\n\n@media (min-width: ").concat(tabs.options.breakpoint, ") {\n  ").concat(tabAllowedClass, " .tabs-panel .accordion-trigger {\n      display: none;\n  }\n  ").concat(tabAllowedClass, " .tabs-tab-list li .tabs-trigger {\n      display: block;\n  }\n  ").concat(tabAllowedClass, " .tabs-panel {\n      display: none;\n  }\n  ").concat(tabAllowedClass, " .tabs-panel.is-hidden {\n      display: none;\n  }\n  ").concat(tabAllowedClass, " .tabs-panel.is-open {\n      display: block;\n  }\n  ").concat(tabAllowedClass, " .tabs-panel.fake-content {\n    display: none;\n  }\n  ").concat(tabAllowedClass, " .tabs-panel {\n      border-top: ").concat(tabs.panelStyle._border, ";\n  }\n  ").concat(tabAllowedClass, " .tabs-tab-list {\n      margin-bottom: -").concat(activeBorderWidth, ";\n  }\n}\n\n").concat(accordionClass, " .accordion-trigger-icon {\n  display: inline-block;\n  float: right;\n  width: 22px;\n  height: 22px;\n}\n\n\n").concat(accordionClass, " .accordion-trigger-icon svg {\n  margin: 0;\n}\n\n").concat(panelClass, " [aria-expanded='true'] .vert {\n  display: none;\n}\n\n").concat(accordionClass, " .accordion-trigger-icon .label--open,\n").concat(accordionClass, " .accordion-trigger-icon .label--close {\n  display: block;\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n").concat(accordionClass, " .accordion-trigger-icon .label--close {\n  display: none;\n}\n\n").concat(panelClass, ".is-open .accordion-trigger .accordion-trigger-icon .label--open {\n  display: none;\n}\n\n").concat(panelClass, ".is-open .accordion-trigger .accordion-trigger-icon .label--close {\n  display: block;\n}\n");
}

function getIconStyles() {
  var icon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var css = '';
  css += icon.size ? "font-size: ".concat(icon.size, ";") : '';
  css += icon.color ? "color: ".concat(isTypeVar(icon.color) ? withVar(icon.color) : icon.color, ";") : '';
  return css;
}

function icon(item) {
  var cssString = '';
  var icon = item.icon;
  var className = getClassName(item);
  var iconStyles = getIconStyles(icon);

  if (iconStyles) {
    cssString += "".concat(className, " .icon {\n            ").concat(iconStyles, "\n        }");
  }

  return cssString;
}

function links(item) {
  var _item$links = item.links,
      links = _item$links === void 0 ? {} : _item$links,
      style = item.style;
  var icon = links.icon;
  var styles = new Styles(item);
  var className = styles.className;
  var linkItemClassName = "".concat(className, " .").concat(prefix, "-list--link");
  var linkItemCombined = styles.combined('links/style', linkItemClassName);
  var listAlign;

  if ((style === null || style === void 0 ? void 0 : style.justifyContent) || (style === null || style === void 0 ? void 0 : style.alignItems)) {
    listAlign = '';
  } else {
    listAlign = getListAlign(links.align, style === null || style === void 0 ? void 0 : style.flexDirection);
  }

  var _getFlexGap = getFlexGap$1(links.gap, style === null || style === void 0 ? void 0 : style.flexDirection),
      _getFlexGap2 = _slicedToArray(_getFlexGap, 2),
      itemsGap = _getFlexGap2[0],
      lastItemNoGap = _getFlexGap2[1];

  var _getIconStyle = getIconStyle$1(icon),
      _getIconStyle$iconSty = _getIconStyle.iconStyles,
      iconStyles = _getIconStyle$iconSty === void 0 ? '' : _getIconStyle$iconSty,
      _getIconStyle$iconPos = _getIconStyle.iconPosition,
      iconPosition = _getIconStyle$iconPos === void 0 ? '' : _getIconStyle$iconPos,
      _getIconStyle$iconGap = _getIconStyle.iconGap,
      iconGap = _getIconStyle$iconGap === void 0 ? '' : _getIconStyle$iconGap;

  var rootStyles = listAlign ? "".concat(className, " {\n            ").concat(listAlign, "\n        }") : '';
  var transition = (style === null || style === void 0 ? void 0 : style.transition) ? "transition: ".concat(style.transition, ";") : '';
  var linkStyles = itemsGap || iconPosition || transition ? "".concat(linkItemClassName, " {\n                ").concat(itemsGap, "\n                ").concat(transition, "\n                ").concat(iconPosition, "\n            }") : '';
  var lastItemNoGapStyle = lastItemNoGap ? "".concat(className, " .").concat(prefix, "-list--item:last-child .").concat(prefix, "-list--link {\n            ").concat(lastItemNoGap, "\n        }") : '';
  var iconElStyles = iconStyles || iconGap ? "".concat(className, " .").concat(prefix, "-list--icon {\n                ").concat(iconStyles, "\n                ").concat(iconGap, "\n            }") : '';
  return "\n        ".concat(rootStyles, "\n        ").concat(linkItemCombined, "\n        ").concat(linkStyles, "\n        ").concat(lastItemNoGapStyle, "\n        ").concat(iconElStyles, "\n    ");
}

function getListAlign(align) {
  var flexDirection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'row';
  if (!align) return '';
  var alignValue = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
  }[align];
  var alignProp = {
    row: 'justify-content',
    column: 'align-items'
  }[flexDirection];
  return "".concat(alignProp, ": ").concat(alignValue, ";");
}

function getFlexGap$1(gap) {
  var flexDirection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'row';
  if (!gap) return '';
  var gapProp = {
    row: 'margin-right',
    column: 'margin-bottom'
  }[flexDirection];
  var gapStyle = "".concat(gapProp, ": ").concat(gap, ";");
  var lastItemNoGap = "".concat(gapProp, ": 0;");
  return [gapStyle, lastItemNoGap];
}

function getIconStyle$1(icon) {
  var result = {};
  var iconStyles = !isEmpty_1(icon === null || icon === void 0 ? void 0 : icon.style) ? styleDeclaration(icon.style) : '';
  result.iconStyles = iconStyles;

  if (icon === null || icon === void 0 ? void 0 : icon.position) {
    var iconPosValue = {
      left: 'row',
      right: 'row-reverse'
    }[icon.position];
    var iconPosition = "flex-direction: ".concat(iconPosValue, ";");
    result.iconPosition = iconPosition;
  }

  if (icon === null || icon === void 0 ? void 0 : icon.gap) {
    var iconGapProp = {
      left: 'margin-right',
      right: 'margin-left'
    }[(icon === null || icon === void 0 ? void 0 : icon.position) || 'left'];
    var iconGap = "".concat(iconGapProp, ": ").concat(icon.gap, ";");
    result.iconGap = iconGap;
  }

  return result;
}

function icon$1(item) {
  var css = '';
  var _item$icon = item.icon,
      icon = _item$icon === void 0 ? {} : _item$icon;
  css += icon.size ? "font-size: ".concat(icon.size, ";") : '';
  css += icon.color ? "color: ".concat(isTypeVar(icon.color) ? withVar(icon.color) : icon.color, ";") : '';
  var iconPosition = getPosition(item.style);
  css += icon.gap ? "margin-".concat(iconPosition, ": ").concat(icon.gap) : '';
  return css;
}

function getPosition(style) {
  if (!style || !style.flexDirection) return 'right';

  switch (style.flexDirection) {
    case 'row-reverse':
      return 'left';

    case 'column':
      return 'bottom';

    default:
      return 'right';
  }
}

function button(item) {
  var className = getClassName(item);
  return "".concat(className, " .icon {\n        ").concat(icon$1(item), "\n    }");
}

function iframe(item) {
  var _item$settings = item.settings,
      settings = _item$settings === void 0 ? {} : _item$settings,
      _item$attr = item.attr,
      attr = _item$attr === void 0 ? {} : _item$attr;
  var height = attr.height,
      width = attr.width;
  var cssString = '';

  if (settings.aspectRatio !== 'ignore' && height && width) {
    cssString += "padding-bottom: ".concat(height / width * 100, "%;");
  } else {
    cssString += "\n            height: ".concat(height, "px;\n            padding-bottom: unset;\n        ");
  }

  return "".concat(getClassName(item), " {\n        ").concat(cssString, "\n        max-width: 100%;\n    }");
}

function column(item) {
  var justifyContent = idx_1(item, function (props) {
    return props.style.justifyContent;
  });

  if (justifyContent && justifyContent !== 'normal') {
    var className = getClassName(item);
    return "".concat(className, " {\n            display: flex; \n            flex-direction: column; \n        }");
  }
}

function heading (item) {
  var styles = new Styles(item);
  var className = styles.className;
  var dynamicTextCombined = styles.combined('dynamicText/style', "".concat(className, " .dorik-heading__dynamic"));
  return "\n      ".concat(className, " p{\n        display:inline;\n      }\n      \n      ").concat(className, " span {\n        display:inline-block;\n      }\n\n      ").concat(dynamicTextCombined, "\n  ");
}

function icon$2(item) {
  var cssString = '';
  var icon = item.icon;
  var className = getClassName(item);
  var iconStyles = getIconStyles$1(icon);
  var textStyles = getTextStyles(icon, getPosition$1(item.style));
  cssString += "".concat(className, " {\n        display: flex;\n    }");

  if (iconStyles) {
    cssString += "".concat(className, " .icon {\n            ").concat(iconStyles, "\n        }");
  }

  if (textStyles) {
    cssString += "".concat(className, " > span {\n            ").concat(textStyles, "\n        }");
  }

  return cssString;
}

function getIconStyles$1() {
  var icon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var css = '';
  css += icon.size ? "font-size: ".concat(icon.size, ";") : '';
  css += icon.color ? "color: ".concat(isTypeVar(icon.color) ? withVar(icon.color) : icon.color, ";") : '';
  return css;
}

function getTextStyles() {
  var icon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var position = arguments.length > 1 ? arguments[1] : undefined;
  var css = '';
  var gapDirection = "padding-".concat(position);
  css += icon.gap ? "".concat(gapDirection, ": ").concat(icon.gap, ";") : '';
  return css;
}

function getPosition$1(style) {
  if (!style || !style.flexDirection) return 'left';

  switch (style.flexDirection) {
    case 'row-reverse':
      return 'right';

    case 'column':
      return 'top';

    default:
      return 'left';
  }
}

function accordion(item) {
  var _item$accordions = item.accordions,
      accordions = _item$accordions === void 0 ? {} : _item$accordions,
      settings = item.settings,
      style = item.style;
  var styles = new Styles(item);
  var margin = accordions.gap ? "margin-bottom:".concat(accordions.gap) : '';
  var className = getClassName(item);
  var accordionsWrapper = "".concat(className, " details");
  var accordionsHeading = "".concat(className, " summary");
  var accordionsParagraph = "".concat(className, " .details-content p");
  var cssString = '';
  var accordionsHeadingCombined = styles.combined('accordions/headingStyle', accordionsHeading);
  var accordionsParagraphCombined = styles.combined('accordions/paragraphStyle', accordionsParagraph);
  return "\n".concat(cssString, "\n\n").concat(accordionsWrapper, " {\n  ").concat(styleDeclaration(accordions.accordionsWrapperStyle), "\n  overflow:hidden;\n  transition: height 1s ease;\n ").concat(margin, "\n}\n\n").concat(accordionsWrapper, ":last-child {\n margin-bottom:0;\n}\n\n").concat(accordionsHeading, " {\n  font-family: sans-serif;\n  cursor: pointer;\n  list-style: none;\n  outline: none;\n}\n\n").concat(accordionsHeadingCombined, "\n\n").concat(accordionsHeading, "::-webkit-details-marker {\n  display: none;\n}\n\n").concat(accordionsHeading, "::before {\n  padding-left: 10px;      \n  font-size: inherit;\n  content: '+';\n  float: right;\n}\n\n").concat(accordionsWrapper, "[open] summary::before {\n  padding-left: 10px;\n  font-size: inherit;\n  content: '-';\n}\n").concat(accordionsParagraphCombined, "\n");
}

function socialIcon (item) {
  var _pseudoClass$hover;

  var _item$style = item.style,
      style = _item$style === void 0 ? {} : _item$style,
      _item$socialIcons = item.socialIcons,
      socialIcons = _item$socialIcons === void 0 ? {
    iconStyle: iconStyle
  } : _item$socialIcons,
      _item$pseudoClass = item.pseudoClass,
      pseudoClass = _item$pseudoClass === void 0 ? {} : _item$pseudoClass;
  var styles = new Styles(item);
  var className = styles.className;
  var iconClass = "".concat(className, " li svg");
  var margin = getSocialIconStyle(style.flexDirection, socialIcons.gap);

  function getSocialIconStyles() {
    var _socialIcons$iconStyl, _socialIcons$iconStyl2;

    var socialIcons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var css = '';

    if (!((_socialIcons$iconStyl = socialIcons.iconStyle) === null || _socialIcons$iconStyl === void 0 ? void 0 : _socialIcons$iconStyl.size)) {
      css += socialIcons.size ? "width: ".concat(socialIcons.size, "; \n            height: ").concat(socialIcons.size, ";") : '';
    }

    if (!((_socialIcons$iconStyl2 = socialIcons.iconStyle) === null || _socialIcons$iconStyl2 === void 0 ? void 0 : _socialIcons$iconStyl2.fill)) {
      css += socialIcons.color ? "fill: ".concat(isTypeVar(socialIcons.color) ? withVar(socialIcons.color) : socialIcons.color, ";") : '';
    }

    return css;
  }

  function getSocialIconHoverStyles() {
    var _socialIcons$iconStyl3;

    var socialIcons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var css = '';

    if (!((_socialIcons$iconStyl3 = socialIcons.iconStyle) === null || _socialIcons$iconStyl3 === void 0 ? void 0 : _socialIcons$iconStyl3.fill)) {
      css += socialIcons.color ? "fill: ".concat(isTypeVar(socialIcons.color) ? withVar(socialIcons.color) : socialIcons.color, ";") : '';
    }

    return css;
  }

  var iconClassCombined = styles.combined('socialIcons/iconStyle', iconClass);
  return "\n\n".concat(className, " {\n    padding:0;\n    margin:0;\n    flex-wrap:wrap;\n}\n\n").concat(iconClass, " {\n    ").concat(getSocialIconStyles(socialIcons), "\n}\n\n").concat(iconClass, ":hover {\n    ").concat(getSocialIconHoverStyles(pseudoClass === null || pseudoClass === void 0 ? void 0 : (_pseudoClass$hover = pseudoClass.hover) === null || _pseudoClass$hover === void 0 ? void 0 : _pseudoClass$hover.socialIcons), "\n}\n\n").concat(iconClassCombined, "\n\n\n\n").concat(className, " li:not(:last-child){\n    ").concat(margin, ";\n}\n");

  function getSocialIconStyle(direction, gap) {
    var prop = {
      row: 'margin-right',
      column: 'margin-bottom'
    }[direction || 'row'];
    return "".concat(prop, ":").concat(gap);
  }
}

function counterdown(item) {
  var _item$counter = item.counter,
      counter = _item$counter === void 0 ? {} : _item$counter;
  var styles = new Styles(item);
  var className = getClassName(item);
  var counterWrapperClassName = "".concat(className, " .counter-wrapper");
  var counterValueClassName = "".concat(counterWrapperClassName, " .counter-value");
  var counterTextClassName = "".concat(counterWrapperClassName, " .counter-text");
  var counterSeparatorClassName = "".concat(className, " .counter--separator");
  var cssStrign = '';
  var counterStyle = getCounterStyle(counter.counterWrapperStyle.flexDirection);
  var counterSpacing = getCounterSpacing(counter.counterWrapperStyle.flexDirection);
  var counterAlign = getCounterAlign(counter.align);
  var counterValueCombined = styles.combined("counter/countStyle", counterValueClassName);
  var counterSeparatorLineCombined = styles.combined("counter/separatorStyle/line", "".concat(counterSeparatorClassName, "__line"));
  var counterSeparatorColonCombined = styles.combined("counter/separatorStyle/colon", "".concat(counterSeparatorClassName, "__colon"));
  var counterTextCombined = styles.combined("counter/textStyle", counterTextClassName);
  var classNameCombined = styles.combined("style", className);
  return "\n  ".concat(cssStrign, "\n\n  ").concat(className, " {\n    display:flex;\n    justify-content:space-evenly;\n    align-items:center;\n    overflow:hidden;\n    ").concat(counterAlign ? counterAlign : '', "\n  }\n\n  ").concat(className, " .finish-text{\n    font-size:").concat(counter.textStyle.fontSize, ";\n    color:").concat(isTypeVar(counter.textStyle.color) ? withVar(counter.textStyle.color) : counter.textStyle.color, ";\n  }\n\n  ").concat(classNameCombined, "\n  \n  ").concat(counterWrapperClassName, " {\n    display: flex;\n    justify-content: center;\n    ").concat(counterStyle, "\n    position: relative;\n    padding: 0;\n    line-height:1.3;\n    ").concat(styleDeclaration(counter.counterWrapperStyle), "\n  }\n\n  ").concat(counterWrapperClassName, " > *:first-child{\n    ").concat(counterSpacing, "\n  }\n  \n  ").concat(className, " .getTime {\n    display:none;\n  }\n  \n  ").concat(counterValueCombined, "\n  \n  ").concat(counterTextCombined, "\n  \n  ").concat(counterSeparatorClassName, " {\n    display:flex;\n    align-self:stretch;\n    align-items: center;\n  }\n  \n  ").concat(counterSeparatorClassName, "__line {\n    background:").concat(counter.separatorStyle.bgColor, ";\n  }\n\n  ").concat(counterSeparatorLineCombined, "\n\n  ").concat(counterSeparatorClassName, "__colon {\n    color:").concat(counter.separatorStyle.bgColor, ";\n  }\n  \n  ").concat(counterSeparatorColonCombined, "\n\n  @media all and (max-width:767px){\n  ").concat(counterWrapperClassName, " {\n    flex-direction:column;\n    align-items: center;\n    }\n  }\n\n  ");
}
function getCounterAlign(align) {
  if (!align) return '';
  var alignProp = {
    left: 'margin-right',
    center: 'margin',
    right: 'margin-left'
  }[align];
  var alignValue = {
    left: 'auto',
    center: '0 auto',
    right: 'auto'
  }[align];
  return "".concat(alignProp, ": ").concat(alignValue, ";");
}

function getCounterStyle(flexDirection) {
  var alignValue = {
    row: 'baseline',
    column: 'center'
  }[flexDirection];
  return "align-items:".concat(alignValue, ";");
}

function getCounterSpacing(flexDirection) {
  var spacingValue = {
    row: '5px',
    column: ''
  }[flexDirection];
  return "margin-right:".concat(spacingValue, ";");
} //${alignmentResponsiveStyle}

function contactForm(item) {
  var _item$form = item.form,
      form = _item$form === void 0 ? {} : _item$form;
  var className = getClassName(item);
  var cssString = '';

  if (!isEmpty_1(form.buttonWrapperStyle)) {
    cssString += "".concat(className, " .form-button {\n            ").concat(styleDeclaration(form.buttonWrapperStyle), "\n        }");
  }

  return "\n        ".concat(cssString, "\n\n        ").concat(className, " .form-control {\n            width: 100%;\n            ").concat(styleDeclaration(form.fieldStyle), "\n            ").concat(form.gap ? "margin-bottom: ".concat(form.gap, ";") : '', "\n        }\n\n        ").concat(className, " label {\n            display: inline-block;\n            ").concat(styleDeclaration(form.labelStyle), "\n        }\n\n        ").concat(className, " button {\n            ").concat(styleDeclaration(form.buttonStyle), "\n        }\n    ");
}

function subscription(item) {
  var _item$form = item.form,
      form = _item$form === void 0 ? {} : _item$form;
  var margin = form.gap ? form.type === 'vertical' ? "margin-bottom: ".concat(form.gap, ";") : "flex: 1; margin-right: ".concat(form.gap, ";") : '';
  var className = getClassName(item);
  var fieldClassName = className + ' .form-control';
  var fieldsWrapperClassName = className + ' .fields-wrapper';
  var cssString = '';
  cssString += "@media screen and (min-width: 768px) {\n    ".concat(fieldsWrapperClassName, " {\n            display: flex;\n            align-items: flex-end;\n            flex-direction: ").concat(form.type !== 'vertical' ? 'row' : 'column', ";\n        }\n    }");

  if (form.fieldsHeight) {
    cssString += "".concat(fieldClassName, ", ").concat(className, " button {\n            height: ").concat(form.fieldsHeight, ";\n        }");
  }

  return "\n    ".concat(cssString, "\n\n    ").concat(className, " .form-group {\n        ").concat(margin, "\n        width: 100%;\n    }\n    \n    @media screen and (max-width: 767px) {\n        ").concat(className, " .form-group {\n            margin-bottom: 10px;\n        }\n    }\n\n    ").concat(className, " .form-group:last-child {\n        margin: 0;\n    }\n    \n    ").concat(className, " button {\n        ").concat(styleDeclaration(form.buttonStyle), "\n        ").concat(form.type === 'horizontal' ? 'align-self: auto;' : '', "\n    }\n    \n    ").concat(className, " .form-label {\n        display: inline-block;\n        ").concat(styleDeclaration(form.labelStyle), "\n    }\n\n    ").concat(fieldClassName, " {\n        ").concat(styleDeclaration(form.fieldStyle), "\n        width: 100%;\n    }");
}

var itemTypes = {
  nav: nav,
  row: row,
  icon: icon,
  tabs: tabs,
  links: links,
  button: button,
  iframe: iframe,
  column: column,
  heading: heading,
  accordion: accordion,
  iconText: icon$2,
  socialIcon: socialIcon,
  counterdown: counterdown,
  contactForm: contactForm,
  subscription: subscription
};
function itemTypeStyles(item) {
  var func = itemTypes[item.type];
  if (!func) return '';
  return func(item) || '';
}

var sectionFrames = [{
  id: 300,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><path d=\"M500 0v448.944c-44.604 35.874-102.608 57.157-148.309 48.1-64.963-12.743-116.219-89.592-180.468-151.709C106.974 283.218 29.733 235.57 7.174 167.081-10.185 114.38 4.921 50.141 42.082 0H500z\" fill=\"currentColor\"/></svg>"
}, {
  id: 301,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><path d=\"M293.24 500c80.786 0 153.64-32.398 206.676-85.156.112-.111.112-138.364 0-414.76-276.41-.097-414.664-.097-414.76 0C32.842 52.957 0 127.054 0 207.244 0 368.93 131.288 500 293.24 500zm0-124.4c-93.133 0-168.633-75.375-168.633-168.355 0-92.98 75.5-168.355 168.634-168.355 93.134 0 168.634 75.375 168.634 168.355 0 92.98-75.5 168.355-168.634 168.355z\" fill=\"currentColor\" fill-rule=\"nonzero\"/></svg>"
}, {
  id: 302,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><path d=\"M.38 0h499.002v500C220.606 311.333 65.583 203.667 34.312 177 9.03 153-2.28 94 .38 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 303,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><path d=\"M293 500c80.81 0 153.993-35.093 207-88V0L85.612.023C32.71 53.03 0 126.195 0 207c0 161.82 131.18 293 293 293z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 304,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><path d=\"M500 0v435l-191.049 65-190.942-63.437L0 270.484V65.2L46.328 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 305,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M274.576 0L168.188 106.99c-19.334 19.443-19.402 50.831-.151 70.358l.1.101c.11.113.222.224.333.336 19.251 19.154 50.385 19.076 69.54-.175l106.266-106.8L416 0h14.491L323.912 107.18c-19.141 19.25-19.399 50.205-.723 69.77l.572.588.1.102.333.335c19.251 19.155 50.385 19.077 69.54-.174L500 71V0v85.84l-70.168 71.076L323.034 263.18c-19.25 19.154-19.329 50.288-.175 69.538l.336.334.1.099c19.527 19.25 50.915 19.183 70.359-.152L500 227.25V415c-52.477 52.378-124.729 84.356-204.578 84.99L293 500C131.18 500 0 368.82 0 207 0 126.195 34.098 53.006 87 0h187.576z\"/><path d=\"M321.647 107.95L429 0h71v73L393.552 179.617c-19.511 19.542-51.17 19.567-70.711.056a49.987 49.987 0 01-.275-.276l-1.068-1.083c-19.255-19.527-19.188-50.919.15-70.364z\" opacity=\".846\"/><path d=\"M165.71 106.51L272 0h146l-72.18 71.767-107.037 107.591c-19.475 19.577-51.134 19.659-70.71.183a49.982 49.982 0 01-.335-.336l-2.235-2.267c-19.282-19.55-19.19-50.992.207-70.429z\" opacity=\".95\"/><path d=\"M392.33 335.56L500 228l-.038-143.543-71.488 72.421-107.582 107.039c-19.576 19.477-19.656 51.135-.18 70.71.113.114.226.226.34.338l.836.825c19.558 19.284 51.01 19.181 70.443-.23z\" opacity=\".946\"/></g></svg>"
}, {
  id: 306,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M293 500c80.81 0 153.979-32.714 206.986-85.621L500 0H86C33.098 53.006 0 126.195 0 207c0 72.234 74.119 120.913 112 173 48 66 91.415 120 181 120z\" opacity=\".705\"/><path d=\"M293 500c80.81 0 153.979-32.714 206.986-85.621.005-110.425.008-193.244.008-248.457 0-22.385-38.704-27.69-64.994-48.922-17.014-13.74-17-26-42-57S308.63.01 212.945.016C184.65.018 142.334.012 86 0 33.098 53.006 0 126.195 0 207c0 72.18 74.291 117.694 112 173 45 66 91.361 120 181 120z\"/></g></svg>"
}, {
  id: 307,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><path d=\"M200 0h300v300c0 110.457-89.543 200-200 200H0V200C0 89.543 89.543 0 200 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 308,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><path d=\"M0 0h500v500c-155.605-50.938-274.605-117.605-357-200C60.605 217.605 12.938 117.605 0 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 309,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><g fill=\"currentColor\"><path d=\"M499.002 0l.008 429.848c-12.13 4.048-24.19 8.035-36.072 12.026-14.499-58.642-34.095-148.59-115.9-197.241-81.664-48.505-204.646-58.7-283.266 26.784C102.74 374 131.964 463.948 194.145 490.152c14.335 6.063 30.42 8.752 48.04 8.847-17.85-.044-34.136-2.73-48.633-8.864-62.284-26.253-91.557-116.37-130.588-219.146-39.239-102.592-88.65-218.03-45.052-258.806C23.412 7.016 30.384 3.037 38.66.017L499.002 0z\"/><path d=\"M349 245c82.486 49.024 100.389 137.96 115 197-111.721 37.236-206.02 74.661-268.877 48.091-62.647-26.383-92.99-116.345-132.249-219.632C142.084 184.39 266.724 196.163 349 245z\" opacity=\".807\"/></g></svg>"
}, {
  id: 310,
  position: "corner",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M364.148 181.525a135.244 135.244 0 004.376-34.231c0-74.155-59.754-134.27-133.465-134.27-41.87 0-79.237 19.396-103.707 49.744 9.087 1.72 18.48 4.33 27.903 7.843 37.64 14.035 75.279 70.176 112.918 93.598 30.487 18.687 60.975 16.482 91.463 17.3z\" fill-rule=\"nonzero\" opacity=\".845\"/><path d=\"M64.87 70.702c18.896-14.064 56.234-14.45 94.024-.387 37.79 14.063 75.58 70.317 113.37 93.785 37.79 23.117 75.581 14.327 113.371 18.722 37.79 4.395 75.58 23.732 94.476 32.785l18.895 9.405V-.002H0c30.65 56.511 52.274 80.08 64.87 70.704z\" fill-rule=\"nonzero\" opacity=\".845\"/><path d=\"M399.198 457.957c37.182-12.652 63.948-48.041 63.948-89.72 0-52.295-42.14-94.69-94.124-94.69-13.143 0-25.658 2.71-37.02 7.606-9.137 35 49.07 69.908 45.038 104.922-4.104 35.645 10.942 57.37 21.857 71.494z\" fill-rule=\"nonzero\" opacity=\".802\"/><path d=\"M397.482 63.769c14 18.998 41.998 56.994 27.998 94.99-13.999 37.997-69.996 75.993-93.357 113.99-23.011 37.996 45.76 75.87 41.385 113.866-4.375 37.996 12.967 60.207 23.939 74.256 8.644 8.696 42.388 21.515 101.23 38.455V.33C421.88 29.957 388.148 51.103 397.481 63.769z\" fill-rule=\"nonzero\" opacity=\".922\"/><path d=\"M361.552 218.437c8.062 6.251 13.374 8.59 15.937 7.014 8.09-7.678 14.73-14.358 19.92-20.04a245.695 245.695 0 0014.94-18.037c-7.295-2.123-15.263-3.793-23.904-5.01-8.641-1.217-16.941-1.55-24.9-1.002-9.39 18.465-10.054 30.823-1.993 37.075z\"/></g></svg>"
}, {
  id: 8,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><path d=\"M0 109.785l64-19.602c64-19.969 192-58.62 320-39.294 128 19.325 256 98.466 384 98.191 128 .275 256-78.866 384-88.345 128-9.846 256 49.05 384 53.927 128 5.245 256-44.448 320-68.65l64-24.571V0H0v109.785z\" fill=\"currentColor\" /></svg>"
}, {
  id: 9,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M0 111.471l8.267 5.325c8.133 5.126 25.066 16.074 41.066 2.637C65.6 105.997 82.667 69.172 98.667 66.335c16.266-2.637 32 29.212 49.333 47.774 16.133 18.76 32 23.737 49.333 29.211 16 5.474 32 10.45 49.334 2.638 15.866-8.112 32-29.013 49.333-37.124 15.733-7.813 32-2.837 48-10.65 17.067-8.111 33.333-29.012 49.333-23.886 16.934 5.324 33.334 37.173 49.334 34.536C459.467 105.997 476 69.172 492 63.698c16.667-5.474 33.333 21.398 49.333 31.849 16.667 10.45 33.334 5.474 49.334 7.962C607.2 105.997 624 116.945 640 124.759c16.4 8.11 33.333 13.087 49.333 10.599 16.267-2.488 33.334-13.436 49.334-29.212 16.266-16.073 32-36.974 49.333-37.123 16.133.149 32 21.05 49.333 31.848 16 10.6 32 10.6 49.334-5.324 15.866-15.925 32-47.774 49.333-53.098 15.733-5.126 32 15.775 48 21.249 17.067 5.474 33.333-5.474 49.333 0 16.934 5.474 33.334 26.375 49.334 31.849 16.8 5.474 33.333-5.474 49.333-15.925 16.667-10.45 33.333-21.398 49.333-13.287 16.667 7.813 33.334 34.686 49.334 26.574C1247.2 85.096 1264 42.3 1280 45.136c16.4 2.637 33.333 50.41 49.333 71.66 16.267 21.05 33.334 16.074 49.334 5.275 16.266-10.6 32-26.524 49.333-26.524 16.133 0 32 15.924 49.333 5.324 16-10.798 32-47.624 49.334-50.46 15.866-2.638 32 29.211 49.333 31.849 15.733 2.836 32-24.036 48-39.811 17.067-16.074 33.333-21.05 49.333 0 16.934 21.249 33.334 69.022 49.334 74.347 16.8 5.126 33.333-31.7 49.333-58.423 16.667-26.524 33.333-42.449 49.333-23.887 16.667 18.761 33.334 71.511 49.334 90.272 16.533 18.562 33.333 2.638 41.333-5.325l8-7.962V0H0v111.471z\" opacity=\".204\"/><path d=\"M0 88.434l8.267 4.224c8.133 4.066 25.066 12.752 41.066 2.092C65.6 84.091 82.667 54.876 98.667 52.626c16.266-2.092 32 23.174 49.333 37.9 16.133 14.884 32 18.832 49.333 23.175 16 4.342 32 8.29 49.334 2.092 15.866-6.435 32-23.017 49.333-29.452 15.733-6.198 32-2.25 48-8.448 17.067-6.435 33.333-23.017 49.333-18.95 16.934 4.224 33.334 29.49 49.334 27.398C459.467 84.091 476 54.876 492 50.534c16.667-4.343 33.333 16.976 49.333 25.266 16.667 8.291 33.334 4.343 49.334 6.317C607.2 84.091 624 92.777 640 98.975c16.4 6.435 33.333 10.383 49.333 8.409 16.267-1.974 33.334-10.66 49.334-23.175 16.266-12.751 32-29.333 49.333-29.451 16.133.118 32 16.7 49.333 25.267 16 8.409 32 8.409 49.334-4.225 15.866-12.633 32-37.9 49.333-42.124 15.733-4.066 32 12.515 48 16.858 17.067 4.342 33.333-4.343 49.333 0 16.934 4.342 33.334 20.924 49.334 25.266 16.8 4.343 33.333-4.342 49.333-12.633 16.667-8.29 33.333-16.976 49.333-10.541 16.667 6.198 33.334 27.517 49.334 21.082C1247.2 67.51 1264 33.558 1280 35.808c16.4 2.092 33.333 39.992 49.333 56.85 16.267 16.7 33.334 12.752 49.334 4.185 16.266-8.41 32-21.043 49.333-21.043 16.133 0 32 12.634 49.333 4.225 16-8.567 32-37.782 49.334-40.032 15.866-2.093 32 23.174 49.333 25.266 15.733 2.25 32-19.068 48-31.583 17.067-12.752 33.333-16.7 49.333 0 16.934 16.858 33.334 54.758 49.334 58.982C1739.467 96.724 1756 67.51 1772 46.31c16.667-21.042 33.333-33.676 49.333-18.95 16.667 14.884 33.334 56.732 49.334 71.616C1887.2 113.7 1904 101.067 1912 94.75l8-6.316V0H0v88.434z\"/></g></svg>"
}, {
  id: 10,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><path d=\"M0 90c19.465 5.127 55.407 14.597 107.828 28.412 117.946 20.722 145.6 45.44 358.836 22.202C679.9 116.488 1067.056 23.682 1280.292 23.238c213.236.444 426.472 62.61 533.09 94.73L1920 149.495V0H0v90z\" fill=\"currentColor\" /></svg>"
}, {
  id: 11,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M0 78.545L40 63.38c40-15.165 120-45.494 200-40.47 80 5.402 160 45.209 240 55.635 80 10.425 160-10.426 240 5.023 80 14.88 160 66.06 240 55.635 80-10.426 160-80.562 240-85.964 80-5.024 160 55.635 240 80.94 80 24.927 160 15.45 240 5.024 53.333-6.95 133.333-35.574 240-85.87V0H0v78.545z\" opacity=\".203\"/><path d=\"M0 61.265l40-11.829C80 37.608 160 13.951 240 17.87c80 4.214 160 35.264 240 43.396 80 8.132 160-8.132 240 3.918 80 11.606 160 51.527 240 43.395 80-8.132 160-62.838 240-67.052 80-3.918 160 43.395 240 63.134 80 19.443 160 12.05 240 3.918 53.333-5.421 133.333-27.747 240-66.978V0H0v61.265z\"/></g></svg>"
}, {
  id: 12,
  position: "top",
  content: "<svg viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M929 75c-18.105-22.632-30-32.143-49-33.929-46.667 0-340 .596-880 1.786V0h1920v42.857c-540-1.19-833.333-1.786-880-1.786-19 1.786-30.895 11.297-49 33.929-20 25-30.333 50-31 75-.667-25-11-50-31-75z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 13,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 115\"  preserveAspectRatio=\"none\"><path d=\"M959 115L1920 0H0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 14,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 115\" preserveAspectRatio=\"none\"><path d=\"M959 115c320.067 0 640.4-38.333 961-115H0c319.267 76.667 638.933 115 959 115z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 15,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 115\" preserveAspectRatio=\"none\"><path d=\"M1920 0v115h-701l-86-90-86 90h-1l-86-90-86 90h-1l-86-90-86 90H0V0h1920z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 16,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 114\" preserveAspectRatio=\"none\"><path d=\"M1920 0l.002 38.708A56.43 56.43 0 011923 56.915c0 31.334-25.52 56.735-57 56.735-24.536 0-45.452-15.431-53.485-37.075-7.962 21.644-28.694 37.075-53.015 37.075-24.306 0-45.027-15.411-53-37.034-7.973 21.623-28.694 37.034-53 37.034-24.321 0-45.053-15.431-53.016-37.075-8.032 21.644-28.948 37.075-53.484 37.075s-45.452-15.431-53.485-37.075c-7.962 21.644-28.694 37.075-53.015 37.075s-45.053-15.431-53.016-37.075c-8.032 21.644-28.948 37.075-53.484 37.075-24.552 0-45.478-15.45-53.5-37.117-8.022 21.666-28.948 37.117-53.5 37.117-24.536 0-45.452-15.431-53.485-37.075-7.962 21.644-28.694 37.075-53.015 37.075-24.306 0-45.027-15.411-53-37.034-7.973 21.623-28.694 37.034-53 37.034-24.848 0-45.949-16.106-53.515-38.49-7.63 22.384-28.917 38.49-53.985 38.49-24.536 0-45.452-15.431-53.485-37.075-7.962 21.644-28.694 37.075-53.015 37.075s-45.053-15.431-53.016-37.075C739.452 98.219 718.536 113.65 694 113.65c-24.552 0-45.478-15.45-53.5-37.117-8.022 21.666-28.948 37.117-53.5 37.117-24.536 0-45.452-15.431-53.485-37.075-7.962 21.644-28.694 37.075-53.015 37.075-24.306 0-45.027-15.411-53-37.034-7.973 21.623-28.694 37.034-53 37.034-24.321 0-45.053-15.431-53.016-37.075-8.032 21.644-28.948 37.075-53.484 37.075s-45.452-15.431-53.485-37.075c-7.962 21.644-28.694 37.075-53.015 37.075s-45.053-15.431-53.016-37.075C100.452 98.219 79.536 113.65 55 113.65c-25.127 0-46.457-16.183-54.043-38.649L0 75v-3.138a56.554 56.554 0 01-2-14.947c0-5.174.696-10.186 2-14.948V0h1920z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 17,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path opacity=\".1\" d=\"M0 0h1920v150L960 59 0 150z\"/><path opacity=\".204\" d=\"M0 0h1920v150L960 32 0 150z\"/><path d=\"M0 0h1920v150L960 0 0 150z\"/></g></svg>"
}, {
  id: 18,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M0 82.489l8.267 3.94c8.133 3.793 25.066 11.895 41.066 1.952C65.6 78.438 82.667 51.187 98.667 49.088c16.266-1.952 32 21.617 49.333 35.352 16.133 13.884 32 17.566 49.333 21.617 16 4.05 32 7.733 49.334 1.952 15.866-6.003 32-21.47 49.333-27.472 15.733-5.782 32-2.1 48-7.88 17.067-6.003 33.333-21.47 49.333-17.677 16.934 3.94 33.334 27.509 49.334 25.557 16.8-2.1 33.333-29.35 49.333-33.4 16.667-4.051 33.333 15.834 49.333 23.568 16.667 7.733 33.334 4.05 49.334 5.892C607.2 78.437 624 86.539 640 92.32c16.4 6.003 33.333 9.685 49.333 7.844 16.267-1.841 33.334-9.943 49.334-21.617 16.266-11.894 32-27.36 49.333-27.471 16.133.11 32 15.577 49.333 23.568 16 7.844 32 7.844 49.334-3.94 15.866-11.785 32-35.353 49.333-39.293 15.733-3.793 32 11.674 48 15.724 17.067 4.051 33.333-4.05 49.333 0 16.934 4.051 33.334 19.518 49.334 23.569 16.8 4.05 33.333-4.051 49.333-11.785 16.667-7.733 33.333-15.834 49.333-9.832 16.667 5.782 33.334 25.667 49.334 19.665C1247.2 62.97 1264 31.3 1280 33.4c16.4 1.951 33.333 37.304 49.333 53.028 16.267 15.577 33.334 11.895 49.334 3.903 16.266-7.843 32-19.627 49.333-19.627 16.133 0 32 11.784 49.333 3.94 16-7.991 32-35.242 49.334-37.341 15.866-1.952 32 21.616 49.333 23.568 15.733 2.1 32-17.786 48-29.46 17.067-11.895 33.333-15.577 49.333 0 16.934 15.724 33.334 51.077 49.334 55.017 16.8 3.793 33.333-23.458 49.333-43.233 16.667-19.628 33.333-31.412 49.333-17.676 16.667 13.883 33.334 52.918 49.334 66.801 16.533 13.736 33.333 1.952 41.333-3.94l8-5.892V0H0v82.489z\"/><path d=\"M2400 122.618l-12.4 5.857c-12.2 5.639-37.6 17.682-61.6 2.902-24.4-14.78-50-55.288-74-58.408-24.4-2.901-48 32.132-74 52.55-24.2 20.638-48 26.112-74 32.133-24 6.021-48 11.495-74 2.901-23.8-8.922-48-31.913-74-40.836-23.6-8.594-48-3.12-72-11.714-25.6-8.923-50-31.914-74-26.276-25.4 5.857-50 40.891-74 37.99-25.2-3.12-50-43.628-74-49.65-25-6.02-50 23.539-74 35.034-25 11.496-50 6.022-74 8.759-24.8 2.737-50 14.78-74 23.374-24.6 8.923-50 14.397-74 11.66-24.4-2.737-50-14.78-74-32.133-24.4-17.681-48-40.672-74-40.836-24.2.164-48 23.155-74 35.034-24 11.66-48 11.66-74-5.858-23.8-17.517-48-52.55-74-58.408-23.6-5.638-48 17.353-72 23.375-25.6 6.021-50-6.022-74 0-25.4 6.021-50 29.012-74 35.033-25.2 6.022-50-6.021-74-17.517-25-11.495-50-23.538-74-14.615-25 8.594-50 38.154-74 29.231-24.8-8.594-50-55.67-74-52.55-24.6 2.9-50 55.451-74 78.825-24.4 23.156-50 17.682-74 5.803-24.4-11.66-48-29.177-74-29.177-24.2 0-48 17.517-74 5.858-24-11.88-48-52.387-74-55.507-23.8-2.901-48 32.132-74 35.034-23.6 3.12-48-26.44-72-43.793-25.6-17.68-50-23.155-74 0-25.4 23.375-50 75.925-74 81.782-25.2 5.639-50-34.87-74-64.265-25-29.176-50-46.693-74-26.275-25 20.637-50 78.662-74 99.299-24.8 20.418-50 2.901-62-5.857l-12-8.759V0h2880v122.618z\" opacity=\".148\"/><path d=\"M2221 0v85.855c-6.779 5.548-13.602 12.305-20.538 19.131-11.772 4.046-28.382 7.333-44.29-1.477-21.374-11.645-43.801-43.56-64.826-46.018-21.376-2.286-42.05 25.316-64.827 41.403-20.094 15.41-39.873 20.09-61.276 24.576-3.057-1.42-6.137-2.687-9.243-3.753-23.6-8.594-48-3.12-72-11.714-25.6-8.923-50-31.914-74-26.276-5.654 1.304-11.268 4.054-16.845 7.508-8.076-.586-16.16-1.555-24.192-4.142-22.427-7.03-43.803-25.144-64.828-20.702-9.04 1.875-17.963 7.544-26.783 13.46-5.15-3.686-10.27-6.508-15.352-7.783-14.515-3.496-29.03 5.002-43.349 14.995-14.978-10.546-29.739-26.602-44.17-29.858-21.9-4.744-43.802 18.545-64.827 27.602-21.9 9.057-43.802 4.744-64.827 6.9-21.726 2.157-43.802 11.645-64.827 18.417-21.55 7.03-43.802 11.343-64.827 9.186-11.389-1.149-23.076-4.38-34.69-9.214-17.023-13.11-33.9-26.646-51.743-30.849-14.028-9.398-28.165-17.342-43.221-17.427-21.2.129-42.05 18.243-64.827 27.602-21.025 9.186-42.05 9.186-64.827-4.615-20.85-13.801-42.05-41.403-64.828-46.018-20.674-4.442-42.05 13.672-63.074 18.416-22.427 4.744-43.803-4.744-64.828 0-22.251 4.744-43.802 22.858-64.827 27.602-22.076 4.744-43.802-4.744-64.827-13.801-21.9-9.057-43.802-18.545-64.827-11.515-8.39 2.593-16.78 7.611-25.12 12.42-5.217.2-10.399 1.149-15.534 3.058-5.9 2.028-11.8 5.224-17.687 8.806a25.17 25.17 0 01-6.486-1.254C582.101 73.751 560.025 36.66 539 39.118c-10.393 1.102-20.95 11.302-31.452 23.635-9.296-8.331-18.507-14.279-27.548-13.104-19.39 2.287-39.277 35.42-58.584 60.798-4.062-1.29-8.091-2.881-12.07-4.652-21.376-9.187-42.05-22.988-64.827-22.988-21.2 0-42.05 13.801-64.827 4.615-21.025-9.359-42.05-41.274-64.827-43.733-20.85-2.285-42.05 25.317-64.827 27.603-4.415.525-8.86-.124-13.328-1.603-7.814-6.678-15.757-11.947-23.89-13.754-8.63-6.379-17.273-13.564-25.858-19.146-22.426-13.93-43.802-18.244-64.827 0C12.123 45.076 2.252 58.017-7.493 70.166-17.008 62.28-26.535 53.537-36 46.693c-25.6-17.68-50-23.155-74 0l-.686.639c-20.843-20.99-41.648-32.755-61.66-17.444-19.15 14.217-38.3 50.956-56.864 70.831-9.704-11.551-19.31-24.897-28.79-36.509-14.735-17.196-29.47-30.343-44-34.058V0h2523z\" opacity=\".148\"/></g></svg>"
}, {
  id: 19,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M1920 57.59c-171.821 47.008-300.354 63.396-385.598 49.162-127.867-21.35-255.734-64.051-383.6-49.773-127.868 13.744-255.734 85.802-383.601 92.474-127.867 6.672-255.734-49.373-383.6-78.33C255.733 42.702 127.866 42.702 63.932 42.702L0 37V0h1920v57.59z\" opacity=\".149\"/><path d=\"M0 57.59c171.821 47.008 300.354 63.396 385.598 49.162 127.867-21.35 255.734-64.051 383.6-49.773 127.868 13.744 255.734 85.802 383.601 92.474 127.867 6.672 255.734-49.373 383.6-78.33 127.867-28.422 255.734-28.422 319.668-28.422H1920V0H0v57.59z\" opacity=\".296\"/><path d=\"M0 38c171.821 31.032 300.354 41.85 385.598 32.457 127.867-14.092 255.734-42.274 383.6-32.85 127.868 9.07 255.734 56.629 383.601 61.032 127.867 4.404 255.734-32.586 383.6-51.697 127.867-18.76 255.734-18.76 319.668-18.76H1920V0H0v38z\"/></g></svg>"
}, {
  id: 20,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M1920 0v21.154l-45.333 10.578c-31.795 7.206-84.077 19.323-143.225 30.767-27.663-3.5-56.846-6.693-86.109-9.037-91.066-7.658-182.666-7.658-273.333 11.45-40.286 8.243-80.572 20.286-120.747 31.204-51.422-1.507-102.713-2.777-153.92-.921-40.879 1.469-81.573 5.156-122.212 10.326-50.698-11.362-101.433-25.07-152.454-29.158C731.467 68.706 640 91.608 548 114.51l-5.45 1.374c-25.653 6.463-51.388 12.866-77.153 18.348-63.504-20.855-127.247-49.89-190.73-67.264-92-24.658-183.2-24.658-228.934-24.658l-12.776-.001L0 22.902V0h1920z\" opacity=\".299\"/><path d=\"M1920 91.608l-45.733-7.658c-45.734-7.372-136.934-23.117-228.934-30.488-91.066-7.658-182.666-7.658-273.333 11.45-92 18.823-184 57.47-274.667 57.255-91.6.215-182.666-38.432-274.666-45.804C731.467 68.706 640 91.608 548 114.51c-90.8 22.902-182.667 45.804-273.333 30.56C182.8 129.54 92 76.58 45.333 49.597L0 22.902V0h1920v91.608z\" opacity=\".145\"/><path d=\"M0 72.675L45.733 66.6c45.734-5.848 136.934-18.339 228.934-24.187 91.066-6.075 182.666-6.075 273.333 9.084C640 66.43 732 97.09 822.667 96.92c91.6.17 182.666-30.49 274.666-36.337C1188.533 54.506 1280 72.675 1372 90.844c90.8 18.169 182.667 36.338 273.333 24.244 91.867-12.32 182.667-54.336 229.334-75.741L1920 18.169V0H0v72.675z\"/></g></svg>"
}, {
  id: 21,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M0 0h1920v43H0zM960 150l127-107H833z\"/></g></svg>"
}, {
  id: 22,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M0 120l160-13.375C320 93.75 640 66.25 960 53.375 1280 40 1600 40 1760 40h160V0H0v120z\" opacity=\".301\"/><path d=\"M0 150l160-16.719c160-16.094 480-50.469 800-66.562C1280 50 1600 50 1760 50h160V0H0v150z\" opacity=\".15\"/><path d=\"M0 90l160-10.031c160-9.656 480-30.281 800-39.938C1280 30 1600 30 1760 30h160V0H0v90z\"/></g></svg>"
}, {
  id: 23,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M1920 20.429l-80 23.813c-80 24.068-240 71.31-400 68.118-160-3.192-320-58.095-480-57.904-160-.191-320 54.712-480 78.333-160 23.62-320 17.237-400 13.598l-80-3.384V0h1920v20.429z\" opacity=\".101\"/><path d=\"M1920 17.024l-80 19.844c-80 20.057-240 59.425-400 56.765-160-2.66-320-48.413-480-48.253-160-.16-320 45.593-480 65.277-160 19.684-320 14.364-400 11.332l-80-2.82V0h1920v17.024z\" opacity=\".295\"/><path d=\"M1920 12.938l-80 15.082c-80 15.243-240 45.163-400 43.141-160-2.022-320-36.793-480-36.672-160-.121-320 34.65-480 49.61S160 95.016 80 92.712L0 90.569V0h1920v12.938z\"/></g></svg>"
}, {
  id: 24,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><path d=\"M0 0h1920v1L0 150z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 25,
  position: "top",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><path d=\"M0 0h1920v1.273L1331 150 0 1.273z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 26,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><path d=\"M0 40.215l64 19.602c64 19.969 192 58.62 320 39.294C512 79.786 640 .645 768 .92c128-.275 256 78.866 384 88.345 128 9.846 256-49.05 384-53.927 128-5.245 256 44.448 320 68.65l64 24.571V150H0V40.215z\" fill=\"currentColor\" fill-rule=\"nonzero\"/></svg>"
}, {
  id: 27,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><path d=\"M0 60c19.465-5.127 55.407-14.597 107.828-28.412 117.946-20.722 145.6-45.44 358.836-22.202 213.236 24.126 600.392 116.932 813.628 117.376 213.236-.444 426.472-62.61 533.09-94.73L1920 .505V150H0V60z\" fill=\"currentColor\" fill-rule=\"nonzero\"/></svg>"
}, {
  id: 28,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M0 38.529l8.267-5.325c8.133-5.126 25.066-16.074 41.066-2.637C65.6 44.003 82.667 80.828 98.667 83.665c16.266 2.637 32-29.212 49.333-47.774 16.133-18.76 32-23.737 49.333-29.211 16-5.474 32-10.45 49.334-2.638 15.866 8.112 32 29.013 49.333 37.124 15.733 7.813 32 2.837 48 10.65 17.067 8.111 33.333 29.012 49.333 23.886 16.934-5.324 33.334-37.173 49.334-34.536C459.467 44.003 476 80.828 492 86.302c16.667 5.474 33.333-21.398 49.333-31.849 16.667-10.45 33.334-5.474 49.334-7.962C607.2 44.003 624 33.055 640 25.241c16.4-8.11 33.333-13.087 49.333-10.599 16.267 2.488 33.334 13.436 49.334 29.212 16.266 16.073 32 36.974 49.333 37.123 16.133-.149 32-21.05 49.333-31.848 16-10.6 32-10.6 49.334 5.324 15.866 15.925 32 47.774 49.333 53.098 15.733 5.126 32-15.775 48-21.249 17.067-5.474 33.333 5.474 49.333 0 16.934-5.474 33.334-26.375 49.334-31.849 16.8-5.474 33.333 5.474 49.333 15.925 16.667 10.45 33.333 21.398 49.333 13.287 16.667-7.813 33.334-34.686 49.334-26.574C1247.2 64.904 1264 107.7 1280 104.864c16.4-2.637 33.333-50.41 49.333-71.66 16.267-21.05 33.334-16.074 49.334-5.275 16.266 10.6 32 26.524 49.333 26.524 16.133 0 32-15.924 49.333-5.324 16 10.798 32 47.624 49.334 50.46 15.866 2.638 32-29.211 49.333-31.849 15.733-2.836 32 24.036 48 39.811 17.067 16.074 33.333 21.05 49.333 0 16.934-21.249 33.334-69.022 49.334-74.347 16.8-5.126 33.333 31.7 49.333 58.423 16.667 26.524 33.333 42.449 49.333 23.887 16.667-18.761 33.334-71.511 49.334-90.272C1887.2 6.68 1904 22.604 1912 30.567l8 7.962V150H0V38.529z\" opacity=\".204\"/><path d=\"M0 61.566l8.267-4.224C16.4 53.276 33.333 44.59 49.333 55.25 65.6 65.909 82.667 95.124 98.667 97.374c16.266 2.092 32-23.174 49.333-37.9 16.133-14.884 32-18.832 49.333-23.175 16-4.342 32-8.29 49.334-2.092 15.866 6.435 32 23.017 49.333 29.452 15.733 6.198 32 2.25 48 8.448 17.067 6.435 33.333 23.017 49.333 18.95 16.934-4.224 33.334-29.49 49.334-27.398C459.467 65.909 476 95.124 492 99.466c16.667 4.343 33.333-16.976 49.333-25.266 16.667-8.291 33.334-4.343 49.334-6.317C607.2 65.909 624 57.223 640 51.025c16.4-6.435 33.333-10.383 49.333-8.409 16.267 1.974 33.334 10.66 49.334 23.175 16.266 12.751 32 29.333 49.333 29.451 16.133-.118 32-16.7 49.333-25.267 16-8.409 32-8.409 49.334 4.225 15.866 12.633 32 37.9 49.333 42.124 15.733 4.066 32-12.515 48-16.858 17.067-4.342 33.333 4.343 49.333 0 16.934-4.342 33.334-20.924 49.334-25.266 16.8-4.343 33.333 4.342 49.333 12.633 16.667 8.29 33.333 16.976 49.333 10.541 16.667-6.198 33.334-27.517 49.334-21.082 16.533 6.198 33.333 40.15 49.333 37.9 16.4-2.092 33.333-39.992 49.333-56.85 16.267-16.7 33.334-12.752 49.334-4.185 16.266 8.41 32 21.043 49.333 21.043 16.133 0 32-12.634 49.333-4.225 16 8.567 32 37.782 49.334 40.032 15.866 2.093 32-23.174 49.333-25.266 15.733-2.25 32 19.068 48 31.583 17.067 12.752 33.333 16.7 49.333 0 16.934-16.858 33.334-54.758 49.334-58.982 16.8-4.066 33.333 25.148 49.333 46.349 16.667 21.042 33.333 33.676 49.333 18.95 16.667-14.884 33.334-56.732 49.334-71.616C1887.2 36.3 1904 48.933 1912 55.25l8 6.316V150H0V61.566z\"/></g></svg>"
}, {
  id: 29,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M0 71.455L40 86.62c40 15.165 120 45.494 200 40.47 80-5.402 160-45.209 240-55.635 80-10.425 160 10.426 240-5.023 80-14.88 160-66.06 240-55.635 80 10.426 160 80.562 240 85.964 80 5.024 160-55.635 240-80.94 80-24.927 160-15.45 240-5.024 53.333 6.95 133.333 35.574 240 85.87V150H0V71.455z\" opacity=\".203\"/><path d=\"M0 88.735l40 11.829c40 11.828 120 35.485 200 31.567 80-4.214 160-35.264 240-43.396 80-8.132 160 8.132 240-3.918 80-11.606 160-51.527 240-43.395 80 8.132 160 62.838 240 67.052 80 3.918 160-43.395 240-63.134 80-19.443 160-12.05 240-3.918 53.333 5.421 133.333 27.747 240 66.978V150H0V88.735z\"/></g></svg>"
}, {
  id: 30,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><path d=\"M929 75c-18.105 22.632-30 32.143-49 33.929-46.667 0-340-.596-880-1.786V150h1920v-42.857c-540 1.19-833.333 1.786-880 1.786-19-1.786-30.895-11.297-49-33.929-20-25-30.333-50-31-75-.667 25-11 50-31 75z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 31,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 115\" preserveAspectRatio=\"none\"><path d=\"M959 0c320.067 0 640.4 38.333 961 115H0C319.267 38.333 638.933 0 959 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 32,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 115\" preserveAspectRatio=\"none\"><path d=\"M1920 115V0h-701l-86 90-86-90h-1l-86 90-86-90h-1l-86 90-86-90H0v115h1920z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 33,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 114\" preserveAspectRatio=\"none\"><path d=\"M1920 114l.002-38.708A56.43 56.43 0 001923 57.085c0-31.334-25.52-56.735-57-56.735-24.536 0-45.452 15.431-53.485 37.075C1804.553 15.781 1783.821.35 1759.5.35c-24.306 0-45.027 15.411-53 37.034-7.973-21.623-28.694-37.034-53-37.034-24.321 0-45.053 15.431-53.016 37.075C1592.452 15.781 1571.536.35 1547 .35s-45.452 15.431-53.485 37.075C1485.553 15.781 1464.821.35 1440.5.35s-45.053 15.431-53.016 37.075C1379.452 15.781 1358.536.35 1334 .35c-24.552 0-45.478 15.45-53.5 37.117C1272.478 15.8 1251.552.35 1227 .35c-24.536 0-45.452 15.431-53.485 37.075C1165.553 15.781 1144.821.35 1120.5.35c-24.306 0-45.027 15.411-53 37.034-7.973-21.623-28.694-37.034-53-37.034-24.848 0-45.949 16.106-53.515 38.49C953.355 16.456 932.068.35 907 .35c-24.536 0-45.452 15.431-53.485 37.075C845.553 15.781 824.821.35 800.5.35s-45.053 15.431-53.016 37.075C739.452 15.781 718.536.35 694 .35c-24.552 0-45.478 15.45-53.5 37.117C632.478 15.8 611.552.35 587 .35c-24.536 0-45.452 15.431-53.485 37.075C525.553 15.781 504.821.35 480.5.35c-24.306 0-45.027 15.411-53 37.034C419.526 15.761 398.805.35 374.5.35c-24.321 0-45.053 15.431-53.016 37.075C313.452 15.781 292.536.35 268 .35s-45.452 15.431-53.485 37.075C206.553 15.781 185.821.35 161.5.35s-45.053 15.431-53.016 37.075C100.452 15.781 79.536.35 55 .35 29.873.35 8.543 16.533.957 38.999L0 39v3.138a56.554 56.554 0 00-2 14.947c0 5.174.696 10.186 2 14.948V114h1920z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 34,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path opacity=\".1\" d=\"M0 150h1920V0L960 91 0 0z\"/><path opacity=\".204\" d=\"M0 150h1920V0L960 118 0 0z\"/><path d=\"M0 150h1920V0L960 150 0 0z\"/></g></svg>"
}, {
  id: 35,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M1920 92.41c-171.821-47.008-300.354-63.396-385.598-49.162-127.867 21.35-255.734 64.051-383.6 49.773C1022.933 79.277 895.067 7.219 767.2.547 639.334-6.125 511.467 49.92 383.6 78.877c-127.867 28.422-255.734 28.422-319.668 28.422L0 113v37h1920V92.41z\" opacity=\".149\"/><path d=\"M0 92.41c171.821-47.008 300.354-63.396 385.598-49.162 127.867 21.35 255.734 64.051 383.6 49.773C897.067 79.277 1024.933 7.219 1152.8.547c127.867-6.672 255.734 49.373 383.6 78.33 127.867 28.422 255.734 28.422 319.668 28.422H1920V150H0V92.41z\" opacity=\".296\"/><path d=\"M0 112c171.821-31.032 300.354-41.85 385.598-32.457 127.867 14.092 255.734 42.274 383.6 32.85 127.868-9.07 255.734-56.629 383.601-61.032 127.867-4.404 255.734 32.586 383.6 51.697 127.867 18.76 255.734 18.76 319.668 18.76H1920V150H0v-38z\"/></g></svg>"
}, {
  id: 36,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M0 150h1920v-43H0zM960 0l127 107H833z\"/></g></svg>"
}, {
  id: 37,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M1920 129.571l-80-23.813c-80-24.068-240-71.31-400-68.118-160 3.192-320 58.095-480 57.904-160 .191-320-54.712-480-78.333C320-6.409 160-.026 80 3.613L0 6.997V150h1920v-20.429z\" opacity=\".101\"/><path d=\"M1920 132.976l-80-19.844c-80-20.057-240-59.425-400-56.765-160 2.66-320 48.413-480 48.253-160 .16-320-45.593-480-65.277C320 19.659 160 24.979 80 28.01l-80 2.82V150h1920v-17.024z\" opacity=\".295\"/><path d=\"M1920 137.062l-80-15.082c-80-15.243-240-45.163-400-43.141-160 2.022-320 36.793-480 36.672-160 .121-320-34.65-480-49.61S160 54.984 80 57.288L0 59.431V150h1920v-12.938z\"/></g></svg>"
}, {
  id: 38,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><path d=\"M0 150h1920v-1L0 0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 39,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><path d=\"M0 150h1920v-1.273L1331 0 0 148.727z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 40,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 115\" preserveAspectRatio=\"none\"><path d=\"M959 0l961 115H0z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>"
}, {
  id: 41,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M0 30l160 13.375C320 56.25 640 83.75 960 96.625 1280 110 1600 110 1760 110h160v40H0V30z\" opacity=\".301\"/><path d=\"M0 0l160 16.719C320 32.812 640 67.187 960 83.28 1280 100 1600 100 1760 100h160v50H0V0z\" opacity=\".15\"/><path d=\"M0 60l160 10.031c160 9.656 480 30.281 800 39.938C1280 120 1600 120 1760 120h160v30H0V60z\"/></g></svg>"
}, {
  id: 42,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M0 67.511l8.267-3.94c8.133-3.793 25.066-11.895 41.066-1.952 16.267 9.943 33.334 37.194 49.334 39.293 16.266 1.952 32-21.617 49.333-35.352 16.133-13.884 32-17.566 49.333-21.617 16-4.05 32-7.733 49.334-1.952 15.866 6.003 32 21.47 49.333 27.472 15.733 5.782 32 2.1 48 7.88 17.067 6.003 33.333 21.47 49.333 17.677 16.934-3.94 33.334-27.509 49.334-25.557 16.8 2.1 33.333 29.35 49.333 33.4 16.667 4.051 33.333-15.834 49.333-23.568 16.667-7.733 33.334-4.05 49.334-5.892C607.2 71.563 624 63.461 640 57.68c16.4-6.003 33.333-9.685 49.333-7.844 16.267 1.841 33.334 9.943 49.334 21.617 16.266 11.894 32 27.36 49.333 27.471 16.133-.11 32-15.577 49.333-23.568 16-7.844 32-7.844 49.334 3.94 15.866 11.785 32 35.353 49.333 39.293 15.733 3.793 32-11.674 48-15.724 17.067-4.051 33.333 4.05 49.333 0 16.934-4.051 33.334-19.518 49.334-23.569 16.8-4.05 33.333 4.051 49.333 11.785 16.667 7.733 33.333 15.834 49.333 9.832 16.667-5.782 33.334-25.667 49.334-19.665C1247.2 87.03 1264 118.7 1280 116.6c16.4-1.951 33.333-37.304 49.333-53.028 16.267-15.577 33.334-11.895 49.334-3.903 16.266 7.843 32 19.627 49.333 19.627 16.133 0 32-11.784 49.333-3.94 16 7.991 32 35.242 49.334 37.341 15.866 1.952 32-21.616 49.333-23.568 15.733-2.1 32 17.786 48 29.46 17.067 11.895 33.333 15.577 49.333 0 16.934-15.724 33.334-51.077 49.334-55.017 16.8-3.793 33.333 23.458 49.333 43.233 16.667 19.628 33.333 31.412 49.333 17.676 16.667-13.883 33.334-52.918 49.334-66.801C1887.2 43.943 1904 55.727 1912 61.619l8 5.892V150H0V67.511z\"/><path d=\"M2400 27.382l-12.4-5.857c-12.2-5.639-37.6-17.682-61.6-2.902-24.4 14.78-50 55.288-74 58.408-24.4 2.901-48-32.132-74-52.55-24.2-20.638-48-26.112-74-32.133-24-6.021-48-11.495-74-2.901-23.8 8.922-48 31.913-74 40.836-23.6 8.594-48 3.12-72 11.714-25.6 8.923-50 31.914-74 26.276-25.4-5.857-50-40.891-74-37.99-25.2 3.12-50 43.628-74 49.65-25 6.02-50-23.539-74-35.034-25-11.496-50-6.022-74-8.759-24.8-2.737-50-14.78-74-23.374-24.6-8.923-50-14.397-74-11.66-24.4 2.737-50 14.78-74 32.133-24.4 17.681-48 40.672-74 40.836-24.2-.164-48-23.155-74-35.034-24-11.66-48-11.66-74 5.858-23.8 17.517-48 52.55-74 58.408-23.6 5.638-48-17.353-72-23.375-25.6-6.021-50 6.022-74 0-25.4-6.021-50-29.012-74-35.033-25.2-6.022-50 6.021-74 17.517-25 11.495-50 23.538-74 14.615-25-8.594-50-38.154-74-29.231-24.8 8.594-50 55.67-74 52.55-24.6-2.9-50-55.451-74-78.825-24.4-23.156-50-17.682-74-5.803-24.4 11.66-48 29.177-74 29.177-24.2 0-48-17.517-74-5.858-24 11.88-48 52.387-74 55.507-23.8 2.901-48-32.132-74-35.034-23.6-3.12-48 26.44-72 43.793-25.6 17.68-50 23.155-74 0-25.4-23.375-50-75.925-74-81.782-25.2-5.639-50 34.87-74 64.265-25 29.176-50 46.693-74 26.275-25-20.637-50-78.662-74-99.299-24.8-20.418-50-2.901-62 5.857l-12 8.759V150h2880V27.382z\" opacity=\".148\"/><path d=\"M2221 150V64.145c-6.779-5.548-13.602-12.305-20.538-19.131-11.772-4.046-28.382-7.333-44.29 1.477-21.374 11.645-43.801 43.56-64.826 46.018-21.376 2.286-42.05-25.316-64.827-41.403-20.094-15.41-39.873-20.09-61.276-24.576-3.057 1.42-6.137 2.687-9.243 3.753-23.6 8.594-48 3.12-72 11.714-25.6 8.923-50 31.914-74 26.276-5.654-1.304-11.268-4.054-16.845-7.508-8.076.586-16.16 1.555-24.192 4.142-22.427 7.03-43.803 25.144-64.828 20.702-9.04-1.875-17.963-7.544-26.783-13.46-5.15 3.686-10.27 6.508-15.352 7.783-14.515 3.496-29.03-5.002-43.349-14.995-14.978 10.546-29.739 26.602-44.17 29.858-21.9 4.744-43.802-18.545-64.827-27.602-21.9-9.057-43.802-4.744-64.827-6.9-21.726-2.157-43.802-11.645-64.827-18.417-21.55-7.03-43.802-11.343-64.827-9.186-11.389 1.149-23.076 4.38-34.69 9.214-17.023 13.11-33.9 26.646-51.743 30.849-14.028 9.398-28.165 17.342-43.221 17.427-21.2-.129-42.05-18.243-64.827-27.602-21.025-9.186-42.05-9.186-64.827 4.615-20.85 13.801-42.05 41.403-64.828 46.018-20.674 4.442-42.05-13.672-63.074-18.416-22.427-4.744-43.803 4.744-64.828 0-22.251-4.744-43.802-22.858-64.827-27.602-22.076-4.744-43.802 4.744-64.827 13.801-21.9 9.057-43.802 18.545-64.827 11.515-8.39-2.593-16.78-7.611-25.12-12.42-5.217-.2-10.399-1.149-15.534-3.058-5.9-2.028-11.8-5.224-17.687-8.806a25.17 25.17 0 00-6.486 1.254c-21.726 6.77-43.802 43.862-64.827 41.403-10.393-1.102-20.95-11.302-31.452-23.635-9.296 8.331-18.507 14.279-27.548 13.104-19.39-2.287-39.277-35.42-58.584-60.798-4.062 1.29-8.091 2.881-12.07 4.652-21.376 9.187-42.05 22.988-64.827 22.988-21.2 0-42.05-13.801-64.827-4.615-21.025 9.359-42.05 41.274-64.827 43.733-20.85 2.285-42.05-25.317-64.827-27.603-4.415-.525-8.86.124-13.328 1.603-7.814 6.678-15.757 11.947-23.89 13.754-8.63 6.379-17.273 13.564-25.858 19.146-22.426 13.93-43.802 18.244-64.827 0-10.012-8.287-19.883-21.228-29.628-33.377C-17.008 87.72-26.535 96.463-36 103.307c-25.6 17.68-50 23.155-74 0l-.686-.639c-20.843 20.99-41.648 32.755-61.66 17.444-19.15-14.217-38.3-50.956-56.864-70.831-9.704 11.551-19.31 24.897-28.79 36.509-14.735 17.196-29.47 30.343-44 34.058V150h2523z\" opacity=\".148\"/></g></svg>"
}, {
  id: 43,
  position: "bottom",
  content: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1920 150\" preserveAspectRatio=\"none\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M1920 150v-21.154l-45.333-10.578c-31.795-7.206-84.077-19.323-143.225-30.767-27.663 3.5-56.846 6.693-86.109 9.037-91.066 7.658-182.666 7.658-273.333-11.45-40.286-8.243-80.572-20.286-120.747-31.204-51.422 1.507-102.713 2.777-153.92.921-40.879-1.469-81.573-5.156-122.212-10.326-50.698 11.362-101.433 25.07-152.454 29.158C731.467 81.294 640 58.392 548 35.49l-5.45-1.374c-25.653-6.463-51.388-12.866-77.153-18.348-63.504 20.855-127.247 49.89-190.73 67.264-92 24.658-183.2 24.658-228.934 24.658l-12.776.001L0 127.098V150h1920z\" opacity=\".299\"/><path d=\"M1920 58.392l-45.733 7.658c-45.734 7.372-136.934 23.117-228.934 30.488-91.066 7.658-182.666 7.658-273.333-11.45-92-18.823-184-57.47-274.667-57.255-91.6-.215-182.666 38.432-274.666 45.804C731.467 81.294 640 58.392 548 35.49 457.2 12.589 365.333-10.313 274.667 4.93 182.8 20.46 92 73.42 45.333 100.403L0 127.098V150h1920V58.392z\" opacity=\".145\"/><path d=\"M0 77.325L45.733 83.4c45.734 5.848 136.934 18.339 228.934 24.187 91.066 6.075 182.666 6.075 273.333-9.084C640 83.57 732 52.91 822.667 53.08c91.6-.17 182.666 30.49 274.666 36.337C1188.533 95.494 1280 77.325 1372 59.156c90.8-18.169 182.667-36.338 273.333-24.244 91.867 12.32 182.667 54.336 229.334 75.741L1920 131.831V150H0V77.325z\"/></g></svg>"
}];

function setPosition(_ref) {
  var position = _ref.position,
      frame = _ref.frame;

  if (position === 'corner') {
    var _frame$cornerPosition = frame.cornerPosition,
        cornerPosition = _frame$cornerPosition === void 0 ? 'top-right' : _frame$cornerPosition;

    if (cornerPosition === 'top-left') {
      return "\n                top: 0;\n                left: 0;\n            ";
    } else if (cornerPosition === 'top-right') {
      return "\n                top: 0;\n                right: 0;\n            ";
    } else if (cornerPosition === 'bottom-left') {
      return "\n                bottom: 0;\n                left: 0;\n            ";
    } else if (cornerPosition === 'bottom-right') {
      return "\n                bottom: 0;\n                right: 0;\n            ";
    }
  }

  return position === 'top' ? "\n            top: 0;\n            left: 0;\n            right: 0;\n          " : "\n            left: 0;\n            right: 0;\n            bottom: 0;\n          ";
}

var generateBase64 = function generateBase64(frame) {
  var svg = sectionFrames.find(function (f) {
    return f.id === frame.frameId;
  });
  var content = svg ? svg.content : '';

  if (svg && frame.color) {
    content = svg.content.replace(/fill=".*?"/, "fill=\"".concat(frame.color, "\""));
  }

  var dataImg = Buffer.from(content);
  return 'url(data:image/svg+xml;base64,' + dataImg.toString('base64') + ')';
};

var generateFrame = function generateFrame(_ref2) {
  var frame = _ref2.frame,
      position = _ref2.position;
  var width = frame.width || (position === 'corner' ? '250px' : '100%');
  var height = frame.height || (position === 'corner' ? '250px' : '150px');
  return "\n        ".concat(setPosition({
    position: position,
    frame: frame
  }), "\n        position: absolute;\n        transform: ").concat(frame.flip ? frame.flip : '', ";\n        background-repeat: no-repeat;\n        background-image: ").concat(generateBase64(frame), ";\n        width: ").concat(width, ";\n        height: ").concat(height, ";\n        background-size: ").concat(width, " ").concat(height, ";\n");
};

function tagStyles(tags) {
  return Object.entries(tags).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        tag = _ref2[0],
        props = _ref2[1];

    return "".concat(tag, " {\n            ").concat(styleDeclaration(props.style), "\n        }");
  }).join('\n');
}

function styleDeclarations() {
  var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var settingStyle = arguments.length > 1 ? arguments[1] : undefined;
  var getParentStyle = arguments.length > 2 ? arguments[2] : undefined;
  var cssString = '';
  Object.entries(style).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        prop = _ref2[0],
        value = _ref2[1];

    // if settings is turned off for specific property
    var disabled = settingStyle && settingStyle[prop] === false; // adding CSS declaration with existing ones.

    cssString += disabled ? '' : buildStyle.css(prop, value, getParentStyle);
  });
  return cssString;
}

function generalStyles(item, className, settingStyle, getRootStyle) {
  var style = item.style,
      _item$advanced = item.advanced;
  var cssString = '';

  if (!isEmpty_1(item.style)) {
    cssString += "".concat(className, " {\n            ").concat(styleDeclarations(item.style, settingStyle, getRootStyle), "\n        }\n    ");
  } // pseudoClass styles


  if (!isEmpty_1(item.pseudoClass)) {
    Object.keys(item.pseudoClass).forEach(function (pseudo) {
      if (!isEmpty_1(item.pseudoClass[pseudo].style)) {
        cssString += "".concat(className, ":").concat(pseudo, " {\n                ").concat(styleDeclarations(item.pseudoClass[pseudo].style, null, getRootStyle), "\n            }");
      }
    });
  }

  if (!isEmpty_1(item.wrapper)) {
    cssString += "".concat(className, "-wrapper {\n").concat(styleDeclarations(item.wrapper), "\n}\n");
  }

  return cssString;
}

function mediaQueryStyles(media, className, getParentStyle) {
  var devices = {
    tablet: '1023px',
    mobile: '767px'
  };
  var cssString = '';
  Object.entries(devices).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        device = _ref4[0],
        size = _ref4[1];

    if (!isEmpty_1(media[device])) {
      cssString += "@media screen and (max-width: ".concat(size, ") {\n                ").concat(generalStyles(media[device], className, null, getParentStyle), "\n            }");
    }
  });
  return cssString;
}

var globalStyles = function globalStyles(item) {
  var media = item.media,
      settings = item.settings;
  var cssString = '';

  if (settings) {
    var _settings$colors = settings.colors,
        colors = _settings$colors === void 0 ? [] : _settings$colors; // Global Colors

    cssString += ":root {\n            ".concat(getColorVars(colors), "\n        }");
  }

  cssString += generalStyles(item, 'body');

  if (item.heading) {
    Object.entries(item.heading).forEach(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          selector = _ref6[0],
          obj = _ref6[1];

      cssString += generalStyles(obj, selector);
    });
  }

  if (item.tags) {
    cssString += tagStyles(item.tags);
  }

  if (media) {
    var devices = {
      tablet: '1023px',
      mobile: '767px'
    };
    Object.entries(devices).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          device = _ref8[0],
          size = _ref8[1];

      if (!isEmpty_1(media[device])) {
        cssString += "@media screen and (max-width: ".concat(size, ") {\n                    ").concat(generalStyles(media[device], 'body'), "\n                }\n");
        var heading = media[device].heading;

        if (heading) {
          var styles = Object.entries(heading).map(function (_ref9) {
            var _ref10 = _slicedToArray(_ref9, 2),
                selector = _ref10[0],
                obj = _ref10[1];

            return generalStyles(obj, selector);
          }).join('\n');
          cssString += "@media screen and (max-width: ".concat(size, ") {\n                        ").concat(styles, "\n                    }");
        }
      }
    });
  }

  if (settings) {
    var containerWidth = settings.containerWidth,
        columnGap = settings.columnGap; // Global container width

    if (containerWidth) {
      cssString += "\n            @media all and (min-width: 1280px) {\n                .container {\n                    width: ".concat(containerWidth, ";\n                }\n            }");
    }

    if (columnGap) {
      cssString += ".flex {\n                margin-left: calc(-".concat(columnGap, " / 2);\n                margin-right: calc(-").concat(columnGap, " / 2);\n            }\n            [class*=\"col-\"] {\n                padding-left: calc(").concat(columnGap, " / 2);\n                padding-right: calc(").concat(columnGap, " / 2);\n            }");
    }
  }

  return cssString;
};
/**
 * The function generates CSS style decleration
 * from given builder element object
 * @param {Object} item It accepts an object of full content
 * @returns {string} - A CSS style decleration
 */

function styleGenerator(item) {
  var cssString = '';
  var _item$advanced2 = item.advanced,
      advanced = _item$advanced2 === void 0 ? {} : _item$advanced2;
  var _advanced$customStyle = advanced.customStyle,
      customStyle = _advanced$customStyle === void 0 ? {} : _advanced$customStyle;

  var _ref11 = item.settings || {},
      _ref11$style = _ref11.style,
      settingStyle = _ref11$style === void 0 ? {} : _ref11$style;

  var className = ".".concat(prefix, "-").concat(item.type, "-").concat(item.id);

  function getParentStyle(property) {
    return item.style[property];
  }

  cssString += "\n/*".concat(item.name, "*/\n");
  cssString += generalStyles(item, className, settingStyle, getParentStyle);
  cssString += customStyleGenerator({
    className: className,
    style: customStyle
  });

  if (!isEmpty_1(item.media)) {
    cssString += mediaQueryStyles(item.media, className, getParentStyle);
  } // Generate element type specific styles


  cssString += itemTypeStyles(item); // Section frame styles

  if (item.type === 'section' && 'frames' in item) {
    Object.entries(item.frames).filter(function (_ref12) {
      var _ref13 = _slicedToArray(_ref12, 2),
          _ = _ref13[0],
          f = _ref13[1];

      return f.frameId;
    }).map(function (_ref14) {
      var _ref15 = _slicedToArray(_ref14, 2),
          position = _ref15[0],
          frame = _ref15[1];

      cssString += "".concat(className, "-frame-").concat(position, " {\n            ").concat(generateFrame({
        frame: frame,
        position: position
      }), "\n        }");
    });
  }

  return cssString;
}

function customStyleGenerator(_ref16) {
  var style = _ref16.style,
      className = _ref16.className;
  var customStyle = Object.entries(style).filter(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
        _ = _ref18[0],
        value = _ref18[1];

    return value.trim();
  }).map(function (_ref19) {
    var _ref20 = _slicedToArray(_ref19, 2),
        key = _ref20[0],
        value = _ref20[1];

    value = value.replace(/\s+/gm, ' ');

    if (key.startsWith('&')) {
      var selector = className + key.slice(1);
      return "".concat(selector, " { ").concat(value, " }");
    } else {
      return "".concat(className, " { ").concat(value, " }");
    }
  });
  return customStyle.join('\n');
}

export default styleGenerator;
export { globalStyles, styleDeclarations };
